/* Card Guard theme JS — cart drawer, Buy 5 Get 1 FREE picker, toast, notify modal, product page */
(function () {
  'use strict';

  /* ── Money ── */
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var format = (window.CardGuard && window.CardGuard.moneyFormat) || '${{amount}}';
    return format
      .replace(/\{\{\s*amount\s*\}\}/, Number(value).toLocaleString('en-AU', { minimumFractionDigits: 2 }))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString('en-AU'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  /* ── Toast ── */
  var toastTimer;
  window.showToast = function (msg) {
    var toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = msg;
    placeToast(toast);
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2800);
  };

  /* With the cart open, a message sits inside it, just above the footer, and
     above it in the stacking order (.cart-toast.in-cart, header.liquid). At
     its usual spot — bottom right, z-index 999 — it was under the drawer
     (1200), so everything the cart said went unseen: "Your Ruby Red Guard is
     FREE!", "Only 3 left in stock", "Something went wrong". */
  function placeToast(toast) {
    var dd = document.getElementById('cart-dropdown');
    var inCart = !!(cartOpen && dd && dd.classList.contains('open'));
    toast.classList.toggle('in-cart', inCart);
    if (!inCart) { toast.style.bottom = ''; return; }
    var foot = document.getElementById('cart-footer');
    var top = foot && foot.style.display !== 'none' ? foot.getBoundingClientRect().top : window.innerHeight - 24;
    toast.style.bottom = Math.max(16, Math.round(window.innerHeight - top + 12)) + 'px';
  }

  /* ── Cart dropdown ── */
  var cartOpen = false;
  /* Most recent cart Shopify gave us, used to check stock before adding */
  var lastCart = null;

  /* Every read and change of the cart runs one at a time, in order, each
     worked out from the cart as the one before it left it. Two in flight at
     once (an add while the free guard was still being moved, + tapped
     mid-update, a refresh landing after a change) each worked from the same
     old cart, and the later one could quietly undo the earlier: a guard
     dropped, the wrong one left free, a stale drawer. Adds were already
     queued; now everything is. A task must never wait on queueCart() itself
     or it waits forever — inside one, use loadCart(), not refreshCart(). */
  var cartQueue = Promise.resolve();
  function queueCart(task) {
    var run = cartQueue.then(task, task);
    cartQueue = run.then(null, function () {});
    return run;
  }

  function cartEls() {
    return {
      dropdown: document.getElementById('cart-dropdown'),
      items: document.getElementById('cart-items'),
      footer: document.getElementById('cart-footer'),
      count: document.getElementById('cart-count'),
      total: document.getElementById('cart-total')
    };
  }

  window.toggleCart = function (e) {
    if (e) e.stopPropagation();
    cartOpen ? window.closeCart() : window.openCartDropdown();
  };

  /* The drawer on screen. The mobile menu shuts first: the cart button stops
     its click, so the menu's own tap-outside handler never saw it and the
     menu was still open behind the cart once the cart closed. */
  function showDrawer() {
    cartOpen = true;
    if (window.closeMobileMenu) window.closeMobileMenu();
    var els = cartEls();
    if (els.dropdown) els.dropdown.classList.add('open');
    var ov = document.getElementById('cart-overlay');
    if (ov) ov.classList.add('open');
  }

  window.openCartDropdown = function () {
    showDrawer();
    return refreshCart();
  };

  window.closeCart = function () {
    var wasOpen = cartOpen;
    cartOpen = false;
    var els = cartEls();
    if (els.dropdown) els.dropdown.classList.remove('open');
    var ov = document.getElementById('cart-overlay');
    if (ov) ov.classList.remove('open');
    /* On /cart the lines are Liquid. If the drawer changed the cart, the page
       under it is out of date, so it reloads once the drawer shuts. */
    if (wasOpen && pageCartSig !== null && lastCart && cartSig(lastCart) !== pageCartSig) window.location.reload();
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cartOpen) window.closeCart();
  });

  function emptyCartHtml() {
    return '<div class="cart-empty">' +
      '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" style="color:var(--mid);margin-bottom:0.75rem;"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
      '<p>Your cart is empty</p>' +
      '<a class="cart-shop-btn" href="/#shop" onclick="closeCart()">Browse guards</a>' +
      '</div>';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ── Buy 5 Get 1 FREE ──
     Every 6th guard in the cart is FREE, and it is always the most expensive
     guard in the cart (user, 2026-09-29: "If i add 5 guards in, and then
     click to add another guard to cart it should automatically be free
     (Makes the most expensive guard in cart free, as thats whats customers
     are going to try to do regardless)"). Nothing to claim: add a 6th guard
     any way at all — Add to cart, a tile, +, or the picker — and the dearest
     guard in the cart goes FREE, any mix of OG and Prism.

     How the money works:
       * A free unit sits in the cart as the hidden, unlisted product "FREE
         Guard" (handle free-guard). It has one variant per guard, and each
         variant is a Shopify fixed bundle of exactly one of that real guard,
         so it ships as that guard and takes that guard's stock.
       * One automatic discount, "Buy 5 Get 1 FREE": buy 5 from the All
         Guards collection, get 1 FREE Guard at 100% off, repeating,
         combining with shipping discounts only. Only FREE Guard lines are
         ever discounted.
       * normalizePlan() keeps the cart in that shape. After any change it
         moves units between a guard's normal line and its FREE Guard line so
         that floor(guards / 6) units are free and they are the dearest ones.
         A unit is the same physical guard either way, so this only ever
         changes the price, never what ships. Dropping below a multiple of 6
         turns the free unit back into a paid one — nothing is taken out.
       * Shopify splits a paid line when only part of it counts towards the
         deal (10 bought with 1 free comes back as 5 + 5). The drawer shows
         one row per guard whatever the lines are, and a guard's totals are
         what normalizePlan() compares, never its individual lines — so a
         split can't set off a loop.
       * Codes don't combine with the deal. Shopify applies whichever saves
         more, and the drawer says which one won. While a code wins, the cart
         holds no FREE Guard line at all (codeMode): its units sit on the
         guard's own line at the same price, so checkout, the receipt and the
         packing slip never list a "FREE Guard" charged in full. */
  var DEAL = (window.CardGuard || {}).deal || { buy: 5, get: 1, title: 'Buy 5 Get 1 FREE' };
  var DEAL_EVERY = DEAL.buy + DEAL.get;
  var LEGACY_PROP = '_cg_free';

  function jpost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; }, function () { throw {}; });
      return r.json();
    });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  /* The discount's title, and the one-off "Buy 5, Get 1 FREE" spelling */
  function isDealTitle(t) {
    t = String(t || '');
    return t.toLowerCase() === String(DEAL.title).toLowerCase() || /\bbuy\s*\d+,?\s*get\s*\d+\s*free\b/i.test(t);
  }

  function guardList() { return (window.CardGuard || {}).freeGuards || []; }
  function freeHandle() { return (window.CardGuard || {}).freeHandle || 'free-guard'; }

  /* A guard at full price: one of the guards on sale */
  function isGuard(item) {
    var guards = (window.CardGuard || {}).guardHandles || [];
    return !!item && guards.indexOf(item.handle) !== -1;
  }

  /* A free unit: a line of the FREE Guard product */
  function isPick(item) {
    return !!item && item.handle === freeHandle();
  }

  /* A free guard from before 2026-09-29: a real guard line marked _cg_free */
  function isLegacyPick(item) {
    return isGuard(item) && !!(item.properties && item.properties[LEGACY_PROP]);
  }

  function guardById(id) {
    var list = guardList();
    for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(id)) return list[i];
    return null;
  }

  function guardByFreeId(id) {
    var list = guardList();
    for (var i = 0; i < list.length; i++) if (list[i].freeId && String(list[i].freeId) === String(id)) return list[i];
    return null;
  }

  /* The real guard behind a line: the guard itself, or the one a FREE Guard
     line stands for. A guard missing from CardGuard.freeGuards still counts
     towards the deal; it just can't be the free one (no freeId). */
  function guardForLine(item) {
    if (isPick(item)) return guardByFreeId(item.variant_id);
    if (!isGuard(item)) return null;
    return guardById(item.variant_id) || {
      id: item.variant_id, freeId: null, handle: item.handle, price: item.original_price,
      name: String(item.product_title || '').split(' — ')[0], fit: '', img: ''
    };
  }

  function freeFor(n) { return Math.floor(n / DEAL_EVERY) * DEAL.get; }

  function propCount(item) {
    var n = 0, p = (item && item.properties) || {};
    for (var k in p) if (p.hasOwnProperty(k)) n++;
    return n;
  }

  /* Every guard in the cart, grouped by the real guard: its normal lines
     (paid units) and its FREE Guard lines (free units). */
  function guardGroups(cart) {
    var groups = [], byId = {};
    ((cart && cart.items) || []).forEach(function (item) {
      var g = guardForLine(item);
      if (!g) return;
      var grp = byId[g.id];
      if (!grp) {
        grp = byId[g.id] = { g: g, price: g.price || item.original_price || 0, paidLines: [], freeLines: [], paid: 0, free: 0 };
        groups.push(grp);
      }
      if (isPick(item)) { grp.freeLines.push(item); grp.free += item.quantity; }
      else { grp.paidLines.push(item); grp.paid += item.quantity; }
    });
    return groups;
  }

  /* Every guard unit in the cart, paid or free */
  function guardQty(cart) {
    var n = 0;
    guardGroups(cart).forEach(function (grp) { n += grp.paid + grp.free; });
    return n;
  }

  function freeUnitsIn(cart) {
    var n = 0;
    guardGroups(cart).forEach(function (grp) { n += grp.free; });
    return n;
  }

  /* How many units of each guard should be free: floor(guards / 6), the
     dearest first. Equal prices keep whichever is free already, so nothing
     churns. totals: optional { guardId: newTotal } for a quantity change.
     none: a code is beating the deal (codeMode), so no unit is free. A guard
     that sold out after the page was drawn can't take a FREE line (its FREE
     Guard variant won't sell, and the whole update would be refused), so the
     next dearest goes free instead. */
  function freeTargets(groups, totals, none) {
    var list = groups.map(function (grp) {
      var has = totals && Object.prototype.hasOwnProperty.call(totals, String(grp.g.id));
      return { grp: grp, total: has ? totals[String(grp.g.id)] : grp.paid + grp.free, free: 0 };
    });
    var n = 0;
    list.forEach(function (t) { n += t.total; });
    var left = none ? 0 : freeFor(n);
    list.slice().sort(function (a, b) {
      return (b.grp.price - a.grp.price) || (b.grp.free - a.grp.free) ||
        (String(a.grp.g.id) < String(b.grp.g.id) ? -1 : 1);
    }).forEach(function (t) {
      if (!left || !t.grp.g.freeId || (t.grp.g.available === false && !t.grp.free)) return;
      t.free = Math.min(t.total, left);
      left -= t.free;
    });
    return list;
  }

  /* Move a set of lines to a new total: increases go on the first line (or
     a new line by variant id), decreases come off the last lines first.
     Lines that aren't touched keep whatever split Shopify gave them. */
  function adjustLines(lines, target, addKey, updates) {
    var current = 0;
    lines.forEach(function (l) { current += l.quantity; });
    var delta = target - current;
    if (!delta) return false;
    if (delta > 0) {
      if (lines.length) updates[lines[0].key] = lines[0].quantity + delta;
      else updates[addKey] = delta;
      return true;
    }
    for (var i = lines.length - 1; i >= 0 && delta < 0; i--) {
      var take = Math.min(lines[i].quantity, -delta);
      updates[lines[i].key] = lines[i].quantity - take;
      delta += take;
    }
    return true;
  }

  /* ── When a code beats the deal ──
     Shopify gives the cart the code or Buy 5 Get 1 FREE, whichever saves
     more, never both. While the code wins, a FREE Guard line is charged in
     full, and checkout, the order email and the packing slip all listed
     "FREE Guard — Clear Guard" at $29.95 (audit, 2026-09-29). So while a
     code wins the cart holds no FREE Guard line: those units go back on the
     guard's own line at the same price — the total doesn't move, only the
     label — and return to FREE the moment the deal would win again.

     Shopify decides; the cart follows it:
       * FREE lines in the cart, the code applied and the deal on no line:
         Shopify chose the code. That is final for this mix of guards and this
         code. It is remembered (cgCodeWon), and FREE lines are never tried
         again for it, so the cart can't flip back and forth.
       * A code applied and no FREE lines: the deal would be worth its
         dearest floor(guards / 6) units; the code, its share of the full
         price — Shopify's own allocation for this cart over the full price
         is its rate. FREE lines only go in when the deal is worth more; a
         tie leaves the cart as it is.
       * A code Shopify isn't using (the deal won) doesn't count here, and
         with no code the usual plan runs: the free units return. */
  var CODE_WON = 'cgCodeWon';
  var codeWonMem = [];
  function codeWonList() {
    try { return JSON.parse(sessionStorage.getItem(CODE_WON) || '[]') || []; } catch (e) { return codeWonMem; }
  }
  function rememberCodeWon(sig) {
    var list = codeWonList();
    if (list.indexOf(sig) !== -1) return;
    list.push(sig);
    if (list.length > 40) list.shift();
    codeWonMem = list;
    try { sessionStorage.setItem(CODE_WON, JSON.stringify(list)); } catch (e) {}
  }

  /* Units of each guard with the code, as "5:1|1:6#SPIN25": the cart as it
     is, or with totals (a quantity change, guards in the cart only, as
     normalizePlan) and adds ([{ id, qty }] not yet in) on top. */
  function countsSig(cart, totals, adds, code) {
    var c = {};
    guardGroups(cart).forEach(function (grp) {
      var id = String(grp.g.id);
      c[id] = totals && Object.prototype.hasOwnProperty.call(totals, id) ? totals[id] : grp.paid + grp.free;
    });
    (adds || []).forEach(function (a) { var id = String(a.id); c[id] = (c[id] || 0) + a.qty; });
    return Object.keys(c).filter(function (k) { return c[k] > 0; }).sort()
      .map(function (k) { return k + ':' + c[k]; }).join('|') + '#' + code;
  }

  function fullPrice(cart) {
    var sum = 0;
    ((cart && cart.items) || []).forEach(function (i) { sum += i.original_line_price || 0; });
    return sum;
  }

  /* What the applied code takes off a cart whose full price is base. Its
     rate comes from Shopify's own numbers for this cart — the code's
     allocation over the full price (every live code is a percentage off
     everything) — or, failing that, from the rate it states. */
  function codeValueAt(cart, base) {
    var code = appliedCode(cart);
    if (!code) return 0;
    var app = codeApp(cart, code) || {};
    if (app.value_type === 'fixed_amount') return Math.min(base, Math.round(parseFloat(app.value) * 100) || 0);
    var full = fullPrice(cart);
    var got = typeof app.total_allocated_amount === 'number' ? app.total_allocated_amount : null;
    var rate = got !== null && full > 0 ? got / full
      : app.value_type === 'percentage' ? (parseFloat(app.value) || 0) / 100
      : full > 0 ? (cart.total_discount || 0) / full : 0;
    return Math.round(base * rate);
  }

  /* The code that is to win over the deal on this cart (after totals, if
     given), so the cart keeps no FREE line — or '' for the usual plan. */
  function codeMode(cart, totals) {
    var code = cart ? appliedCode(cart) : '';
    /* A code with no share of the goods (free shipping, say) takes nothing
       the deal does: it never competes with it */
    if (!code || !codeApp(cart, code)) return '';
    var groups = guardGroups(cart);
    var free = freeUnitsIn(cart), held = free > 0;
    /* The deal could have taken at least one FREE unit (enough paid guards
       behind it) and Shopify took the code instead */
    var could = Math.min(free, Math.floor((guardQty(cart) - free) / DEAL.buy) * DEAL.get);
    if (could > 0 && dealView(cart).total === 0) rememberCodeWon(countsSig(cart, null, null, code));
    if (codeWonList().indexOf(countsSig(cart, totals, null, code)) !== -1) return code;
    var deal = 0, base = 0;
    freeTargets(groups, totals).forEach(function (t) { deal += t.free * t.grp.price; base += t.total * t.grp.price; });
    if (!deal) return '';
    (cart.items || []).forEach(function (i) { if (!guardForLine(i)) base += i.original_line_price || 0; });
    var off = codeValueAt(cart, base);
    return (held ? off > deal : off >= deal) ? code : '';
  }

  /* The code Shopify is taking off instead of a free guard the cart has
     earned, or '' */
  function codeWinning(cart) {
    if (!cart || !freeFor(guardQty(cart)) || dealView(cart).total > 0) return '';
    return codeMode(cart);
  }

  /* Free units this cart should hold: none while a code wins */
  function freeOwed(cart) {
    var n = 0;
    freeTargets(guardGroups(cart), null, !!codeMode(cart)).forEach(function (t) { n += t.free; });
    return n;
  }

  /* The /cart/update.js body that puts the cart in shape — each guard's
     paid and free units where freeTargets() says, and none free while a
     code wins (codeMode) — or null when it already is. totals: as for
     freeTargets(). */
  function normalizePlan(cart, totals) {
    var updates = {}, any = false;
    freeTargets(guardGroups(cart), totals, !!codeMode(cart, totals)).forEach(function (t) {
      var grp = t.grp;
      var paidLines = grp.paidLines.slice().sort(function (a, b) { return propCount(a) - propCount(b); });
      if (adjustLines(paidLines, t.total - t.free, String(grp.g.id), updates)) any = true;
      if (grp.g.freeId && adjustLines(grp.freeLines, t.free, String(grp.g.freeId), updates)) any = true;
    });
    return any ? updates : null;
  }

  /* Units the deal is really taking off, per real guard: Shopify's discount
     on the lines, not which lines are FREE Guard lines — one of those is
     charged in full while a code wins. */
  function freeByGuard(cart) {
    var out = {};
    dealView(cart).rows.forEach(function (r) {
      var u = r.g && r.unit ? Math.round(r.deal / r.unit) : 0;
      if (u) out[r.g.id] = (out[r.g.id] || 0) + u;
    });
    return out;
  }
  function sumOf(map) {
    var n = 0;
    for (var k in map) if (map.hasOwnProperty(k)) n += map[k];
    return n;
  }

  /* After a change: say which guard just went FREE, which one is back to
     full price and what brings it back, or that a code now saves more — from
     what Shopify actually applied (a FREE line a code beat said "is FREE!").
     Only guards still in the cart: taking the free Ruby out isn't "your Ruby
     is back to full price", and an empty cart isn't told to add 6 more. */
  function announceFreeChange(before, after) {
    var was = freeByGuard(before), now = freeByGuard(after);
    var held = heldByGuard(after);
    var gained = [], lost = [];
    guardGroups(after).forEach(function (grp) { if ((now[grp.g.id] || 0) > (was[grp.g.id] || 0)) gained.push(grp.g); });
    guardGroups(before).forEach(function (grp) { if ((now[grp.g.id] || 0) < (was[grp.g.id] || 0) && held[grp.g.id]) lost.push(grp.g); });
    var fewer = sumOf(now) < sumOf(was);
    var code = fewer ? codeWinning(after) : '';
    if (gained.length) {
      showToast('🎉 ' + (gained.length === 1 ? 'Your ' + gained[0].name + ' is FREE!' : gained.length + ' guards are now FREE!'));
    } else if (code) {
      showToast('Your code ' + code + ' now saves more than a FREE guard, so that’s the one applied — they don’t stack');
    } else if (lost.length && fewer) {
      var need = DEAL_EVERY - (guardQty(after) % DEAL_EVERY);
      showToast('Your ' + lost[0].name + ' is back to full price — add ' + need + ' more guard' + (need === 1 ? '' : 's') + ' to make it FREE again');
    }
  }

  /* Said when the cart couldn't be put in shape: a free guard it has earned
     but doesn't have, or (a code's move back, say) anything else */
  var FREE_FAIL = 'We couldn’t apply your free guard — please try again';
  function shapeFailMsg(cart) {
    return !cart || !cart.items || freeOwed(cart) > freeUnitsNow(dealView(cart)) ? FREE_FAIL : 'That didn’t go through — please try again';
  }

  /* Put the cart in shape if it isn't: one /cart/update.js, queued behind
     whatever else is changing the cart and planned only when its turn comes,
     from the newest cart. Returns true when the fix is on its way (the caller
     leaves drawing to it). The same plan is never sent twice in a row — if
     Shopify wouldn't take it (stock), the cart is shown as it is. */
  var normalizeQueued = false;
  var lastPlanSig = '';
  function autoNormalize(cart) {
    var plan = normalizePlan(cart);
    if (!plan) { lastPlanSig = ''; return false; }
    if (JSON.stringify(plan) === lastPlanSig) return false;
    if (normalizeQueued) return true;
    normalizeQueued = true;
    queueCart(function () {
      normalizeQueued = false;
      var cur = lastCart;
      var p = normalizePlan(cur);
      var sig = p ? JSON.stringify(p) : '';
      if (!p || sig === lastPlanSig) {
        if (!p) lastPlanSig = '';
        renderCart(cur, true);
        return;
      }
      lastPlanSig = sig;
      return jpost('/cart/update.js', { updates: p })
        .then(withCode)
        .then(function (c) {
          /* Drawn first, so the message is placed against the new footer */
          renderCart(c);
          announceFreeChange(cur, c);
        }, function () {
          /* It used to fail in silence, and the deal line told a 6-guard
             cart to "add 5 more". Now it says so, and the deal line offers
             another go (dealHtml). */
          renderCart(cur, true);
          showToast(shapeFailMsg(cur));
        });
    });
    return true;
  }

  /* The same fix, done on the spot inside a queued task, for the moments
     that can't wait their turn: checkout, and straight after a pick. Resolves
     to the cart as it ends up (or as it was, if Shopify refused). A second
     pass follows when Shopify chose a code over the FREE lines just made —
     codeMode remembers that, so the pass takes them straight back out and
     there is never a third. */
  function normalizeNow(cart, again) {
    var plan = cart ? normalizePlan(cart) : null;
    if (!plan) return Promise.resolve(cart);
    return jpost('/cart/update.js', { updates: plan }).then(function (c) {
      return again || !(c && c.items) ? c : normalizeNow(c, true);
    }, function () { return cart; });
  }

  /* The deal has a part in this cart: a guard free, or one owed */
  function dealInvolved(cart) {
    return !!cart && (freeFor(guardQty(cart)) > 0 || freeUnitsIn(cart) > 0);
  }

  /* The deal's share of one line, in cents. line_level_discount_allocations
     is the documented field; items[].discounts is the older one, kept as a
     fallback for a payload that leaves the first out. */
  function lineDealCents(item) {
    var sum = 0;
    var allocs = item.line_level_discount_allocations;
    if (allocs && allocs.length) {
      allocs.forEach(function (a) {
        var app = (a && a.discount_application) || {};
        if (isDealTitle(app.title)) sum += a.amount || 0;
      });
      return sum;
    }
    (item.discounts || []).forEach(function (d) { if (isDealTitle(d.title)) sum += d.amount || 0; });
    return sum;
  }

  /* The cart as the drawer shows it: one row per guard, however many lines
     Shopify holds it on (paid lines, split lines, its FREE Guard line), so
     the +/- on a row is simply how many of that guard the shopper has. Any
     other product gets a row per variant and properties. */
  function dealView(cart) {
    var rows = [], bySig = {};
    ((cart && cart.items) || []).forEach(function (item) {
      var g = guardForLine(item);
      var sig = g ? 'g' + g.id : 'v' + item.variant_id + '|' + JSON.stringify(item.properties || {});
      var row = bySig[sig];
      if (!row) {
        row = bySig[sig] = {
          sig: sig, item: item, g: g, keys: [], quantity: 0, freeLineQty: 0, was: 0, now: 0, deal: 0,
          unit: g ? (g.price || item.original_price || 0) : (item.original_price || 0)
        };
        rows.push(row);
      }
      if (isPick(row.item) && !isPick(item)) row.item = item;
      row.keys.push(item.key);
      row.quantity += item.quantity;
      if (isPick(item)) row.freeLineQty += item.quantity;
      row.was += item.original_line_price || 0;
      row.now += (typeof item.final_line_price === 'number' ? item.final_line_price : item.line_price) || 0;
      row.deal += lineDealCents(item);
    });
    var total = 0;
    rows.forEach(function (r) { total += r.deal; });
    return { rows: rows, total: total };
  }

  /* Units free right now, counted row by row */
  function freeUnitsNow(view) {
    var n = 0;
    view.rows.forEach(function (r) { if (r.unit) n += Math.round(r.deal / r.unit); });
    return n;
  }

  /* A code that won against the deal: the cart holds free units, a code is
     applied, and the deal is nowhere on the lines. */
  function codeBeatsDeal(cart) {
    var code = appliedCode(cart);
    if (!code) return '';
    return (freeUnitsIn(cart) > 0 && dealView(cart).total === 0) ? code : '';
  }

  function codeApp(cart, code) {
    var apps = cart.cart_level_discount_applications || [];
    for (var i = 0; i < apps.length; i++) {
      var a = apps[i]; if (a && a.discount_application) a = a.discount_application;
      if (a && a.type === 'discount_code' && String(a.title).toUpperCase() === code) return a;
    }
    return null;
  }

  /* Every guard unit's price, plus any not yet added: adds = [{ id, qty }]
     by the real guard's id. */
  function unitPrices(cart, adds) {
    var prices = [];
    guardGroups(cart).forEach(function (grp) {
      for (var k = 0; k < grp.paid + grp.free; k++) prices.push(grp.price);
    });
    (adds || []).forEach(function (a) {
      var g = guardById(a.id);
      if (g) for (var k = 0; k < a.qty; k++) prices.push(g.price);
    });
    return prices;
  }

  /* What the deal takes off: the dearest floor(units / 6) units */
  function dealValueFor(prices) {
    var sorted = prices.slice().sort(function (a, b) { return b - a; });
    var v = 0;
    for (var i = 0; i < freeFor(prices.length); i++) v += sorted[i];
    return v;
  }

  /* Would an applied code still beat the deal once these guards went in?
     adds: [{ id, qty }]. Asked before offering a free guard, so the offer is
     never made when Shopify would charge for it. Valued the way codeMode
     values it (a tie keeps the cart as it is: no FREE line, so the code),
     and a mix Shopify has already given to the code stays the code's. */
  function codeWouldWin(cart, adds) {
    var code = appliedCode(cart);
    if (!code) return false;
    var value = dealValueFor(unitPrices(cart, adds));
    if (!value) return true;
    if (codeWonList().indexOf(countsSig(cart, null, adds, code)) !== -1) return true;
    var base = fullPrice(cart);
    (adds || []).forEach(function (a) { var g = guardById(a.id); if (g) base += g.price * a.qty; });
    return codeValueAt(cart, base) >= value;
  }

  /* 5, 11, 17… guards: the next guard in is FREE */
  function nextIsFree(cart) {
    return guardQty(cart) % DEAL_EVERY === DEAL.buy;
  }

  /* Units of each real guard in the cart, whether paid or free: a free unit
     ships the guard it stands for, out of that guard's stock. */
  function heldByGuard(cart) {
    var held = {};
    guardGroups(cart).forEach(function (grp) { held[grp.g.id] = (held[grp.g.id] || 0) + grp.paid + grp.free; });
    return held;
  }

  /* Every guard the picker can offer: on sale, with stock left after the
     cart, a tile's pending paid guards (extra: { id, qty }) and the picks
     made so far (chosen: real guard ids). A chosen guard stays on the grid
     when its last unit is taken, so its tick doesn't vanish. */
  function pickOptions(cart, extra, chosen) {
    var held = heldByGuard(cart);
    if (extra) held[extra.id] = (held[extra.id] || 0) + extra.qty;
    (chosen || []).forEach(function (id) { held[id] = (held[id] || 0) + 1; });
    var out = [];
    guardList().forEach(function (g) {
      if (!g.available || !g.freeId) return;
      var room = typeof g.stock === 'number' ? g.stock - (held[g.id] || 0) : 99;
      var isChosen = (chosen || []).some(function (id) { return String(id) === String(g.id); });
      if (room < 1 && !isChosen) return;
      out.push({ g: g, room: room });
    });
    return out;
  }

  /* The dearest guard still pickable — what the deal is worth at most */
  function bestFreePick(opts) {
    var best = null;
    (opts || []).forEach(function (o) { if (o.room > 0 && (!best || o.g.price > best.g.price)) best = o; });
    return best;
  }

  /* What picking guard g would really do, from the picker's state s ({ cart,
     extra, chosen, need }): its tile's paid guards, the picks so far, this
     one — standing in for any picks still to come. { code } when an applied
     code would still win, so nothing goes free; { instead: guard } when a
     dearer guard is the one that goes free (the dearest always is); {} when
     this guard does. Asked per card: a 20% code loses to a free Prism but
     beats a free Clear (audit, 2026-09-29). */
  function pickVerdict(s, g) {
    var adds = [];
    if (s.extra) adds.push({ id: s.extra.id, qty: s.extra.qty });
    (s.chosen || []).forEach(function (id) { adds.push({ id: id, qty: 1 }); });
    adds.push({ id: g.id, qty: Math.max(1, (s.need || 1) - (s.chosen || []).length) });
    var code = appliedCode(s.cart);
    if (code && codeWouldWin(s.cart, adds)) return { code: code };
    var units = [];
    guardGroups(s.cart).forEach(function (grp) { for (var k = 0; k < grp.paid + grp.free; k++) units.push(grp.g); });
    adds.forEach(function (a) { var ag = guardById(a.id); if (ag) for (var k = 0; k < a.qty; k++) units.push(ag); });
    units.sort(function (a, b) { return b.price - a.price; });
    var n = freeFor(units.length);
    if (!n || g.price >= units[n - 1].price) return {};
    /* Of the dearest, the one freeTargets frees: already free, then the
       lowest id */
    var top = null, topFree = -1;
    guardGroups(s.cart).forEach(function (grp) {
      if (grp.price !== units[0].price || !grp.g.freeId) return;
      if (!top || grp.free > topFree || (grp.free === topFree && String(grp.g.id) < String(top.id))) { top = grp.g; topFree = grp.free; }
    });
    return { instead: top || units[0] };
  }

  /* Is there a guard the picker could offer that would really go in FREE? */
  function anyPickFree(cart, extra, count) {
    var s = { cart: cart, extra: extra || null, chosen: [], need: count || 1 };
    return pickOptions(cart, extra).some(function (o) { return o.room > 0 && !pickVerdict(s, o.g).code; });
  }

  /* A cart from before the rebuild carries its free guards as real guard
     lines marked _cg_free. Swap each for the matching FREE Guard: the old
     line out first (it holds the stock), then the free one in — and if the
     free one won't go in, the guard goes back as a paid one rather than
     vanish from the cart. Returns a promise of the cart. */
  function legacyPlan(cart) {
    var updates = {}, adds = [], back = [], any = false;
    ((cart && cart.items) || []).forEach(function (l) {
      if (!isLegacyPick(l)) return;
      var g = guardById(l.variant_id);
      if (!g || !g.freeId) return;
      updates[l.key] = 0;
      adds.push({ id: Number(g.freeId), quantity: l.quantity });
      back.push({ id: Number(g.id), quantity: l.quantity });
      any = true;
    });
    return any ? { updates: updates, adds: adds, back: back } : null;
  }
  var migrating = false;
  function migrateLegacyPicks(cart) {
    var plan = legacyPlan(cart);
    if (!plan || migrating) return Promise.resolve(cart);
    migrating = true;
    return jpost('/cart/update.js', { updates: plan.updates })
      .then(function () {
        return jpost('/cart/add.js', { items: plan.adds })['catch'](function () {
          return jpost('/cart/add.js', { items: plan.back })['catch'](function () {});
        });
      })
      .then(fetchCart)
      .then(function (c) { migrating = false; return (c && c.items) ? c : cart; },
            function () { migrating = false; return cart; });
  }

  /* 2026-10-18 (owner): free shipping and the free guard both land at five
     guards (free AU shipping on 5+, Buy 5 Get 1 FREE), so the drawer tells
     ONE story with ONE count - a track to five and two reward chips, FREE AU
     shipping and the FREE 6th guard - instead of a deal line and a shipping
     bar that each said "add 1 more" about something different ("cluttered
     and confusing"). Only while the two really coincide: a different
     shipping rule, or anything that isn't a guard in the cart, keeps the
     two separate lines exactly as before. From 2026-10-25 shipping is free
     on 3+ guards, which split them into two lines again until 2026-10-26,
     when the one panel came back with shipping as a stop on the way to the
     6th guard (see rewardsTogether and rwBar). */
  function shipRule() {
    var cg = window.CardGuard || {};
    return { threshold: cg.freeShipThreshold || 0, minQty: cg.freeShipMinQty || 0 };
  }
  /* The same test renderShipProgress makes */
  function shipUnlocked(cart) {
    var r = shipRule();
    return (r.minQty > 0 && cart.item_count >= r.minQty) || (r.threshold > 0 && itemsTotal(cart) >= r.threshold);
  }
  /* 2026-10-26 (owner: the top of the cart "very cluttered ... not as simple
     and easy"): one panel again for any all-guard cart, now that the two
     rewards land at different counts - a short sentence about the next one
     and a slim bar to the 6th guard with both stops on it (rwBar). */
  function rewardsTogether(cart) {
    var m = shipRule().minQty;
    return m > 0 && m <= DEAL_EVERY && cart.item_count === guardQty(cart);
  }
  /* 2026-10-19: the shipping this cart will pay at checkout (standard AU
     post), beside the subtotal in the drawer and on /cart - "+ $12.95 AU
     shipping", kept separate from the price on the owner's call ("not
     combined. So it still looks cheaper"). snippets/cart-ship-note draws the
     same on page load. The note ("FREE AU shipping on 3+ guards") left the
     cart on 2026-10-26 - the rewards panel says it - so only `add` is used.
     With no rates in the theme settings: no add-on, "Shipping at checkout". */
  function shipParts(cart) {
    var cg = window.CardGuard || {};
    var r = shipRule();
    var free = '<b class="ship-note-free">FREE</b>';
    if (shipUnlocked(cart)) return { add: '+ ' + free + ' AU shipping', note: '' };
    if (!(cg.shipStdBreak > 0)) return { add: '', note: 'Shipping at checkout' };
    var rate = itemsTotal(cart) < cg.shipStdBreak ? cg.shipStdOne : cg.shipStdMore;
    return { add: '+ ' + formatMoney(rate) + ' AU shipping', note: r.minQty > 0 ? free + ' AU shipping on ' + r.minQty + '+ guards' : '' };
  }
  var RW_TRUCK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M1.5 6.5h12v9.5h-12zM13.5 10h4.2l3.3 3.4V16h-7.5z" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"/><circle cx="5.5" cy="17.6" r="1.9" fill="currentColor"/><circle cx="17.2" cy="17.6" r="1.9" fill="currentColor"/></svg>';
  var RW_GIFT = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  /* The bar to the 6th guard: free shipping is a stop part-way (the shipping
     rule's count) and the free guard is the end. A stop turns gold once it is
     reached; ready = the free guard is waiting to be chosen or added. */
  function rwBar(n, ready) {
    var m = shipRule().minQty;
    var pct = Math.min(n, DEAL_EVERY) / DEAL_EVERY * 100;
    return '<span class="cd-bar" aria-hidden="true">' +
      '<span class="cd-bar-fill" style="width:' + pct.toFixed(2) + '%"></span>' +
      '<span class="cd-stop' + (n >= m ? ' on' : '') + '" style="left:' + (m / DEAL_EVERY * 100).toFixed(2) + '%">' + RW_TRUCK + '</span>' +
      '<span class="cd-stop cd-stop--end' + (ready ? ' ready' : '') + '">' + RW_GIFT + '</span>' +
      '</span>';
  }

  /* The deal line under the drawer title. One sentence and at most one
     button: progress, "your next guard is FREE", what is already free,
     which discount won when a code beat the deal, or that the free guard
     didn't go on. */
  function dealHtml(cart) {
    var n = guardQty(cart);
    if (!n) return null;
    var view = dealView(cart);
    var freeNow = freeUnitsNow(view);
    var owed = freeOwed(cart) > freeNow;
    var beat = codeWinning(cart);
    var next = nextIsFree(cart);
    var opts = next && !beat ? pickOptions(cart).filter(function (o) { return o.room > 0; }) : [];
    var best = bestFreePick(opts);
    /* With a code on the cart each guard is weighed on its own: a 20% code
       beats a free Clear but not a free Prism. */
    var code = appliedCode(cart);
    var s = { cart: cart, chosen: [], need: 1 };
    var free = code ? opts.filter(function (o) { return !pickVerdict(s, o.g).code; }).length : opts.length;
    var lose = best && !free;
    var need = DEAL.buy - (n % DEAL_EVERY);

    /* Shopify wouldn't take the move (network, a refusal): the cart has
       earned a free guard it doesn't have. Said plainly, with another go —
       it used to tell a 6-guard cart to "add 5 more". */
    if (owed) {
      return { cls: 'is-code', html:
        '<span class="cd-ico" aria-hidden="true">&#10022;</span>' +
        '<span class="cd-txt">We couldn&rsquo;t apply your free guard &mdash; please try again.</span>' +
        '<button type="button" class="cd-btn" data-deal="retry">Try again</button>' };
    }
    if (beat || lose) {
      return { cls: 'is-code', html:
        '<span class="cd-ico" aria-hidden="true">&#10022;</span>' +
        '<span class="cd-txt">Your code <b>' + escapeHtml(beat || code) + '</b> saves more than a FREE guard here, so that&rsquo;s the one applied.</span>' +
        '<button type="button" class="cd-btn cd-btn--ghost" data-deal="swap">Use FREE guard</button>' };
    }
    if (rewardsTogether(cart) && (best || next || freeNow > 0)) {
      if (best || next) {
        var can = best && free < opts.length;
        var nextTxt = freeNow
          ? (can ? 'Your next guard can be <b>FREE</b>!' : 'Your next guard is <b>FREE</b> too!')
          : (can ? 'Your 6th guard can be <b>FREE</b>!' : 'Your 6th guard is <b>FREE</b>!');
        return { cls: 'is-rw is-offer', rw: true, html:
          '<span class="cd-txt">' + nextTxt + (best ? '' : ' Add any guard.') + '</span>' +
          (best ? '<button type="button" class="cd-btn" data-deal="pick">Choose it</button>' : '') +
          (freeNow ? '' : rwBar(n, true)) };
      }
      /* Both rewards in hand: one line, no bar */
      return { cls: 'is-rw is-won', rw: true, html:
        '<span class="cd-ico cd-tick" aria-hidden="true">&#10003;</span>' +
        '<span class="cd-txt"><b>' + (freeNow > 1 ? freeNow + ' FREE guards' : 'FREE guard') + ' + FREE shipping</b> unlocked</span>' };
    }
    if (best) {
      return { cls: 'is-offer', html:
        '<span class="cd-ico" aria-hidden="true">&#127873;</span>' +
        '<span class="cd-txt"><b>' + (free < opts.length ? 'Your next guard can be FREE!' : freeNow ? 'Your next guard is FREE too!' : 'Your next guard is FREE!') + '</b></span>' +
        '<button type="button" class="cd-btn" data-deal="pick">Choose it</button>' };
    }
    if (next) {
      return { cls: 'is-offer', html:
        '<span class="cd-ico" aria-hidden="true">&#127873;</span>' +
        '<span class="cd-txt"><b>Your next guard is FREE</b> &mdash; add any guard</span>' };
    }
    if (freeNow > 0) {
      return { cls: 'is-won', html:
        '<span class="cd-ico cd-tick" aria-hidden="true">&#10003;</span>' +
        '<span class="cd-txt"><b>' + freeNow + ' FREE guard' + (freeNow === 1 ? '' : 's') + '</b> in your cart' +
        ' &middot; add ' + need + ' more to unlock another</span>' };
    }
    /* A code that will still beat the deal once they get there (SPIN25 on
       three guards, say): promising a free guard would be untrue, and the
       code's own chip in the footer already says what they are getting. */
    if (appliedCode(cart)) {
      var low = null, top = null;
      guardGroups(cart).forEach(function (grp) { if (!low || grp.price < low.price) low = grp; });
      guardList().forEach(function (g) { if (g.available && (!top || g.price > top.price)) top = g; });
      if (low && top && codeWouldWin(cart, [{ id: low.g.id, qty: need }, { id: top.id, qty: DEAL.get }])) return null;
    }
    if (rewardsTogether(cart)) {
      var gap = shipRule().minQty - n;
      return { cls: 'is-rw', rw: true, html:
        '<span class="cd-txt">' + (gap > 0
          ? 'Add <b>' + gap + ' more</b> for <b>FREE shipping</b>'
          : '<b>FREE shipping</b> unlocked &middot; add <b>' + need + ' more</b>, get 1 <b>FREE</b>') + '</span>' +
        rwBar(n, false) };
    }
    var pips = '';
    for (var i = 0; i < DEAL.buy; i++) pips += '<i' + (i < DEAL.buy - need ? ' class="on"' : '') + '></i>';
    return { cls: '', html:
      '<span class="cd-pips" aria-hidden="true">' + pips + '<em>+1</em></span>' +
      '<span class="cd-txt">Add <b>' + need + ' more guard' + (need === 1 ? '' : 's') + '</b> &mdash; get 1 <b>FREE</b></span>' };
  }

  function renderDeal(cart, host) {
    host = host || document.getElementById('cart-deal');
    if (!host) return;
    var d = cart ? dealHtml(cart) : null;
    /* The rewards panel covers free shipping too, so the shipping bar
       (drawer and /cart page) hides while it shows - see the CSS on .cg-rw */
    document.documentElement.classList.toggle('cg-rw', !!(d && d.rw));
    if (!d) { host.hidden = true; host.innerHTML = ''; return; }
    host.className = (host.id === 'cart-deal' ? 'cart-deal' : 'cart-deal cart-page-deal') + (d.cls ? ' ' + d.cls : '');
    host.innerHTML = d.html;
    host.hidden = false;
  }

  /* One listener for every deal line, whichever page it is on */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-deal]') : null;
    if (!btn) return;
    var what = btn.getAttribute('data-deal');
    if (what === 'pick') {
      window.cgOpenFreePicker({ count: 1, cart: lastCart });
    } else if (what === 'swap') {
      btn.disabled = true;
      dealArmed = true;
      dealDismissedAt = -1;
      window.cgRemoveCode().then(function () {
        if (document.querySelector('.cart-page')) window.location.reload();
      });
    } else if (what === 'retry') {
      /* The same plan again: autoNormalize won't resend a plan that just
         failed unless it is told to */
      btn.disabled = true;
      lastPlanSig = '';
      if (document.querySelector('.cart-page')) { window.location.reload(); return; }
      refreshCart();
    }
  });

  /* The picker opens by itself once a visit, straight after the shopper's
     own add brings the cart to 5 (11, 17…) — never on a page load, never
     again at a count they've said "Maybe later" to. After that the deal
     line's "Choose it" is always there, and just adding a guard works too. */
  var dealArmed = false;
  var dealDismissedAt = -1;
  var PICKER_SEEN = 'cgPickerSeen';
  function pickerSeen() { try { return sessionStorage.getItem(PICKER_SEEN) === '1'; } catch (e) { return false; } }
  function markPickerSeen() { try { sessionStorage.setItem(PICKER_SEEN, '1'); } catch (e) {} }
  /* A free guard is waiting on this cart and the picker may offer it */
  function offerOpen(cart) {
    /* Only the first time a guard is on offer, at 5. From 11 on the shopper
       has seen the deal work, and the drawer's "Your next guard is FREE too"
       is enough: a pop-up straight after their own add read like the old
       claim-your-free-guard step (user, 2026-09-29). */
    if (!cart || fpState || !nextIsFree(cart) || pickerSeen() || guardQty(cart) >= DEAL_EVERY) return false;
    if (guardQty(cart) === dealDismissedAt) return false;
    /* Not when a code on the cart beats the deal whichever guard is picked */
    return !!bestFreePick(pickOptions(cart)) && anyPickFree(cart);
  }
  function maybeOfferFree(cart) {
    if (!dealArmed) return;
    dealArmed = false;
    if (!offerOpen(cart)) return;
    /* A − (or a quick second +) in the pause used to open it over a cart
       that no longer had a free guard waiting, and the "FREE" pick was then
       charged. So it looks again once anything under way has landed, at the
       cart as it is by then. */
    setTimeout(function () {
      queueCart(function () {
        if (!offerOpen(lastCart)) return;
        markPickerSeen();
        window.cgOpenFreePicker({ count: 1, cart: lastCart });
      });
    }, 420);
  }

  /* Heading to checkout one guard short of a free one: say so once, then
     carry on (go) whether they pick or pass. Not if they've already said
     "Maybe later" at this count. Returns true when the picker opened, so
     the caller holds the navigation. */
  function claimBeforeCheckout(go) {
    var cart = lastCart;
    if (!cart || fpState || !nextIsFree(cart) || guardQty(cart) === dealDismissedAt) return false;
    if (!bestFreePick(pickOptions(cart)) || !anyPickFree(cart)) return false;
    window.cgOpenFreePicker({ count: 1, cart: cart, mode: 'checkout', onDone: go });
    return true;
  }
  /* 2026-10-19 (owner: "Do 1"): Apple Pay / Google Pay / Shop Pay / PayPal in
     the drawer and on /cart (.cart-express). Express pay goes straight to
     payment, past claimBeforeCheckout, so while a FREE guard is waiting on the
     cart (the next guard is free and not chosen yet) the buttons step aside and
     the gold Checkout offers the picker as before (#1038 lost its free guard
     on a path that skipped it). The markup starts hidden; the first cart read
     shows it. */
  function expressHold(cart) {
    if (!cart || !cart.items || !cart.item_count) return true;
    return !!(nextIsFree(cart) && guardQty(cart) !== dealDismissedAt && bestFreePick(pickOptions(cart)) && anyPickFree(cart));
  }
  function syncExpress(cart) {
    var hold = expressHold(cart);
    document.querySelectorAll('.cart-express').forEach(function (el) { el.hidden = hold; });
  }
  document.addEventListener('cg:cart', function (e) { syncExpress(e.detail); });
  /* Before checkout, anything still on its way to Shopify lands, and the
     cart is put in shape from a fresh read. Checkout tapped straight after a
     6th guard went in could otherwise get there before the free guard had
     moved, and charge for it. Resolves to { cart, ok }: ok is false when the
     cart couldn't be read or put in shape. */
  function settleForCheckout() {
    return queueCart(function () {
      return fetchCart().then(normalizeNow).then(function (c) {
        if (c && c.items) lastCart = c;
        return c;
      });
    }).then(function (c) {
      return { cart: c, ok: !!(c && c.items) && !normalizePlan(c) };
    }, function () { return { cart: lastCart, ok: false }; });
  }
  /* A settle that failed on a cart the deal is part of holds checkout once,
     with the reason on screen — it used to go on in silence and charge for
     the free guard. Never twice in a row: the next tap goes to checkout
     whatever happens, so a shopper is never stuck. */
  var settleMissed = false;
  function holdCheckout(res) {
    if (res.ok || settleMissed || !dealInvolved((res.cart && res.cart.items) ? res.cart : lastCart)) {
      settleMissed = false;
      return false;
    }
    settleMissed = true;
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('.cart-checkout-btn') : null;
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    if (a.getAttribute('aria-busy') === 'true') return;
    a.setAttribute('aria-busy', 'true');
    var go = function () { window.location.href = a.href; };
    settleForCheckout().then(function (res) {
      a.removeAttribute('aria-busy');
      if (holdCheckout(res)) {
        if (res.cart && res.cart.items) renderCart(res.cart, true);
        showToast(shapeFailMsg(res.cart));
        return;
      }
      if (!claimBeforeCheckout(go)) go();
    });
  });

  /* ── The /cart page ──
     Its lines are Liquid, one row per guard like the drawer: a guard's paid
     lines, any split Shopify made, and its FREE Guard line under one
     quantity. Update, Remove and Checkout all come through here. The rows
     become the same guard totals the drawer sends (normalizePlan), so every
     6th guard ends up free and the dearest is the one; then the page
     reloads, or goes on to checkout. Posting the form as it stands sends
     each line's own number and skips all of that; a checkout straight after
     a change used to leave the free guard where it was. */
  function cartPageWants(form) {
    var totals = {}, lines = {};
    form.querySelectorAll('[data-cg-row]').forEach(function (row) {
      var input = row.querySelector('.cg-row-qty');
      if (!input) return;
      var q = parseInt(String(input.value).trim(), 10);
      if (isNaN(q) || q < 0) q = parseInt(input.getAttribute('data-original'), 10) || 0;
      var gid = row.getAttribute('data-guard');
      var keys = String(row.getAttribute('data-keys') || '').split(',').filter(Boolean);
      /* A guard can span two rows (a line with properties is a row of its
         own): its total is both rows, not whichever came last. */
      if (gid) totals[gid] = (totals[gid] || 0) + q;
      else keys.forEach(function (k, i) { lines[k] = i === 0 ? q : 0; });
    });
    /* No more than there is: paid and free units ship from the same stock */
    for (var gid in totals) {
      if (!totals.hasOwnProperty(gid)) continue;
      var left = stockLeft(gid);
      if (left !== null && totals[gid] > left) totals[gid] = left;
    }
    return { totals: totals, lines: lines };
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.cart-page button[type="submit"]') : null;
    if (b && b.form) b.form.setAttribute('data-cg-submitter', b.name || '');
  });
  /* A number typed past stock on /cart comes straight back down to what
     there is, and says so, before Update or Checkout. Capture phase, so the
     page's own row-sharing (main-cart.liquid) sees the capped number. */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('cg-row-qty')) return;
    var row = input.closest('[data-cg-row]');
    var gid = row && row.getAttribute('data-guard');
    var left = gid ? stockLeft(gid) : null;
    if (left === null || !(parseInt(input.value, 10) > left)) return;
    input.value = left;
    var nameEl = row.querySelector('.cart-item-name');
    showToast('Only ' + left + ' of ' + (nameEl ? nameEl.textContent.trim() : 'this guard') + ' left in stock');
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest || !form.closest('.cart-page') || form.getAttribute('data-cg-native')) return;
    if (!form.querySelector('[data-cg-row]')) return;
    e.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;
    var how = (e.submitter && e.submitter.name) || form.getAttribute('data-cg-submitter') || 'update';
    form.removeAttribute('data-cg-submitter');
    var toCheckout = how === 'checkout';
    var want = cartPageWants(form);
    form.setAttribute('aria-busy', 'true');
    queueCart(function () {
      return fetchCart().then(function (cart) {
        var updates = normalizePlan(cart, want.totals) || {};
        /* Lines that aren't guards, by key — only keys the cart still has */
        (cart.items || []).forEach(function (i) {
          if (Object.prototype.hasOwnProperty.call(want.lines, i.key)) updates[i.key] = want.lines[i.key];
        });
        var any = false;
        for (var k in updates) if (updates.hasOwnProperty(k)) { any = true; break; }
        var sent = any ? jpost('/cart/update.js', { updates: updates }) : Promise.resolve(cart);
        /* A guard the rows named that the cart no longer holds is skipped
           by normalizePlan; one more pass puts the result in shape. */
        return sent.then(normalizeNow);
      }).then(function (c) { if (c && c.items) lastCart = c; return c; });
    }).then(function (c) {
      form.removeAttribute('aria-busy');
      if (!toCheckout) { window.location.reload(); return; }
      /* The free guard didn't go on: say so and stay, once (holdCheckout) */
      if (holdCheckout({ cart: c, ok: !!(c && c.items) && !normalizePlan(c) })) {
        var pageDeal = document.getElementById('cart-page-deal');
        if (pageDeal && c && c.items) renderDeal(c, pageDeal);
        showToast(shapeFailMsg(c));
        return;
      }
      var go = function () { window.location.href = (window.CardGuard && window.CardGuard.cartUrl || '/cart') + '/checkout'; };
      if (!claimBeforeCheckout(go)) go();
    }, function () {
      form.removeAttribute('aria-busy');
      if (toCheckout && holdCheckout({ cart: lastCart, ok: false })) { showToast(shapeFailMsg(null)); return; }
      /* Couldn't do it the careful way: the form posts itself */
      form.setAttribute('data-cg-native', '1');
      if (toCheckout) {
        var h = document.createElement('input');
        h.type = 'hidden'; h.name = 'checkout'; h.value = '1';
        form.appendChild(h);
      }
      form.submit();
    });
  });

  /* The value of what's actually in the cart: goods after EVERY discount, with
     no shipping or tax. That is /cart.js total_price — it never carries postage
     or tax, only the lines. items_subtotal_price is the figure BEFORE discounts,
     and final_line_price ignores a code applied across the cart, so a shopper
     who arrived on a /discount/CODE link (every ad and email does this) used to
     see full price here while checkout took 15% off. Summing line_price is the
     fallback for a payload that omits total_price. */
  function itemsTotal(cart) {
    if (!cart) return 0;
    if (typeof cart.total_price === 'number') return cart.total_price;
    var sum = 0;
    (cart.items || []).forEach(function (i) { sum += (typeof i.line_price === 'number' ? i.line_price : i.final_line_price) || 0; });
    return sum;
  }

  /* The saving, as one line under the subtotal, with the full price struck
     through beside the subtotal. It used to be a boxed "YOU'RE SAVING" panel
     with a row per discount; the footer now leaves that room to the guards
     (user, 2026-09-28: "more space for products"). Built from
     items[].discounts, which carries both the automatic deal and a code's
     per-line share, so nothing is missed either way. */
  function renderCartDiscounts(cart) {
    var host = document.getElementById('cart-save');
    var totals = {}, order = [];
    (cart.items || []).forEach(function (i) {
      (i.discounts || []).forEach(function (d) {
        var t = d.title || '';
        if (!t) return;
        if (!(t in totals)) { totals[t] = 0; order.push(t); }
        totals[t] += d.amount || 0;
      });
    });
    var saved = 0;
    order.forEach(function (t) { saved += totals[t]; });
    var was = document.getElementById('cart-total-was');
    if (!saved) {
      if (host) { host.hidden = true; host.innerHTML = ''; }
      if (was) was.remove();
      return;
    }
    if (host) {
      var codes = cartCodes(cart);
      var names = order.map(function (t) {
        if (isDealTitle(t)) return DEAL.title;
        var up = String(t).toUpperCase();
        if (codes.indexOf(up) === -1) return t;
        var pct = codePct(cart, up);
        return up + (pct ? ' ' + pct + '% off' : '');
      }).filter(function (n, i, all) { return all.indexOf(n) === i; });
      host.innerHTML = '<span class="cart-save-amt">You save ' + formatMoney(saved) + '</span>' +
        '<span class="cart-save-why">' + escapeHtml(names.join(' + ')) + '</span>';
      host.hidden = false;
    }
    /* Full price beside the subtotal, struck through, so the drop reads at a
       glance. */
    var totalEl = document.getElementById('cart-total');
    if (totalEl) {
      if (!was) {
        was = document.createElement('s');
        was.id = 'cart-total-was';
        was.className = 'cart-total-was';
        was.setAttribute('aria-label', 'Full price');
        totalEl.parentNode.insertBefore(was, totalEl);
      }
      was.textContent = formatMoney(itemsTotal(cart) + saved);
    }
  }

  function renderShipProgress(cart) {
    var wrap = document.getElementById('ship-progress');
    if (!wrap) return;

    var threshold = (window.CardGuard && window.CardGuard.freeShipThreshold) || 0;
    var minQty = (window.CardGuard && window.CardGuard.freeShipMinQty) || 0;
    if ((threshold <= 0 && minQty <= 0) || cart.item_count === 0) {
      wrap.style.display = 'none';
      return;
    }

    var msg = document.getElementById('ship-progress-msg');
    var fill = document.getElementById('ship-progress-fill');
    var marker = document.getElementById('ship-progress-marker');
    /* Goods only. Shopify tests the free-shipping threshold against the
       discounted item subtotal, so the bar has to measure the same number or
       it promises free shipping the checkout won't give. */
    var goods = itemsTotal(cart);
    /* The offer is counted in guards (user, 2026-10-02; 3+ since 2026-10-25):
       three or more ship free through the automatic "Free shipping on 3+
       guards" discount, whatever code is on the cart (3 x $29.95 less 15% is
       $76.38). The $89.85 rate is only a quiet backstop, so it can unlock
       the bar but is never the number the shopper is asked for. */
    var unlocked = (minQty > 0 && cart.item_count >= minQty) || (threshold > 0 && goods >= threshold);
    var pct, gap;
    if (minQty > 0) {
      gap = minQty - cart.item_count;
      pct = Math.round((cart.item_count / minQty) * 100);
    } else {
      gap = threshold - goods;
      pct = Math.round((goods / threshold) * 100);
    }
    if (unlocked) pct = 100;
    pct = Math.max(0, Math.min(100, pct));

    if (!unlocked) {
      wrap.classList.remove('unlocked');
      if (msg) msg.innerHTML = minQty > 0
        ? 'You’re <strong>ONLY ' + gap + ' guard' + (gap === 1 ? '' : 's') + '</strong> away from <strong>FREE AU SHIPPING!</strong>'
        : 'You’re <strong>ONLY ' + formatMoney(gap) + '</strong> away from <strong>FREE AU SHIPPING!</strong>';
    } else {
      wrap.classList.add('unlocked');
      if (msg) msg.innerHTML = '🎉 <strong>You’ve unlocked FREE AU SHIPPING!</strong>';
    }
    if (fill) fill.style.width = pct + '%';
    if (marker) marker.style.left = pct + '%';
    wrap.style.display = 'block';
  }

  /* Single source of truth for guard photography — the same banner shots used
     in the hero. Keyed colour|case. Update here and the cart and
     everything else follow. */
  var GUARD_PHOTOS = {
    'clear|PSA': 'https://cdn.shopify.com/s/files/1/0795/9602/8103/files/cardguard-hero-5.jpg?v=1784529819',
    'clear|BGS': 'https://cdn.shopify.com/s/files/1/0795/9602/8103/files/hero-clear-bgs-new.jpg?v=1784593882',
    'black|PSA': 'https://cdn.shopify.com/s/files/1/0795/9602/8103/files/cardguard-hero-3.jpg?v=1784248255',
    'black|BGS': 'https://cdn.shopify.com/s/files/1/0795/9602/8103/files/cardguard-hero-4.jpg?v=1784529819'
  };

  /* Product-page clips, keyed the same way as GUARD_PHOTOS. Each ends on the
     settled wide shot, which is the framing used for the still — so playing
     forward lands on the photo rather than cutting away from it. */
  var VP = 'https://cdn.shopify.com/videos/c/vp/';
  var VPOSTER = 'https://cdn.shopify.com/s/files/1/0795/9602/8103/files/preview_images/';
  var GUARD_VIDEOS = {
    'clear-guard|PSA': {
      hd: VP + '4908e4dbf4c04d89bc7c163e47b78130/4908e4dbf4c04d89bc7c163e47b78130.HD-720p-4.5Mbps-90445236.mp4',
      sd: VP + '4908e4dbf4c04d89bc7c163e47b78130/4908e4dbf4c04d89bc7c163e47b78130.SD-480p-1.5Mbps-90445236.mp4',
      poster: VPOSTER + '4908e4dbf4c04d89bc7c163e47b78130.thumbnail.0000000000.jpg?v=1785507065'
    },
    'clear-guard|BGS': {
      hd: VP + 'c91c12ffcef248a5964fd1da2b47b501/c91c12ffcef248a5964fd1da2b47b501.HD-720p-4.5Mbps-90445237.mp4',
      sd: VP + 'c91c12ffcef248a5964fd1da2b47b501/c91c12ffcef248a5964fd1da2b47b501.SD-480p-1.5Mbps-90445237.mp4',
      poster: VPOSTER + 'c91c12ffcef248a5964fd1da2b47b501.thumbnail.0000000000.jpg?v=1785507065'
    },
    'black-guard|PSA': {
      hd: VP + 'a705b4d2fcfa40828a7c65b57f5cc999/a705b4d2fcfa40828a7c65b57f5cc999.HD-720p-4.5Mbps-90445238.mp4',
      sd: VP + 'a705b4d2fcfa40828a7c65b57f5cc999/a705b4d2fcfa40828a7c65b57f5cc999.SD-480p-1.5Mbps-90445238.mp4',
      poster: VPOSTER + 'a705b4d2fcfa40828a7c65b57f5cc999.thumbnail.0000000000.jpg?v=1785507066'
    },
    'black-guard|BGS': {
      hd: VP + '782d5092de614841ac2edc1a1e98de42/782d5092de614841ac2edc1a1e98de42.HD-720p-3.0Mbps-90445239.mp4',
      sd: VP + '782d5092de614841ac2edc1a1e98de42/782d5092de614841ac2edc1a1e98de42.SD-480p-1.2Mbps-90445239.mp4',
      poster: VPOSTER + '782d5092de614841ac2edc1a1e98de42.thumbnail.0000000000.jpg?v=1785507065'
    }
  };

  var CART_IMAGES = {
    'clear-guard|PSA': GUARD_PHOTOS['clear|PSA'],
    'clear-guard|BGS': GUARD_PHOTOS['clear|BGS'],
    'black-guard|PSA': GUARD_PHOTOS['black|PSA'],
    'black-guard|BGS': GUARD_PHOTOS['black|BGS']
  };

  function cartImageFor(item) {
    var handle = item.handle || '';
    var url = CART_IMAGES[handle + '|' + (item.variant_title || '')];
    if (!url) url = item.image;
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=260';
  }

  /* Stock left for a variant, or null when Shopify isn't capping it */
  function stockLeft(variantId) {
    var s = (window.CardGuard || {}).stock || {};
    var n = s[String(variantId)];
    return (typeof n === 'number') ? n : null;
  }

  /* ── Guard counting ──
     A pack is a separate product with its own inventory, so the guards inside
     it only exist as line-item properties ("Guard 3": "Black — PSA Case").
     Shopify therefore can't tell that a 10-pack empties a guard we have 6 of.
     Everything below exists to count guards wherever they're hiding — loose
     lines or inside packs — so one check in addOne can cover every path. */

  /* "Black — PSA Case" -> "black|PSA" */
  function guardKey(label) {
    var s = String(label || '');
    var colour = s.split(/[\s—]+/)[0].toLowerCase().trim();
    var m = s.match(/\b(PSA|BGS)\b/i);
    if (!colour || !m) return null;
    return colour + '|' + m[1].toUpperCase();
  }

  /* "black|PSA" -> "Black PSA". Named for the key it takes, because
     initProductPage has its own guardName() for the selected variant and the
     two would otherwise shadow each other. */
  function guardNameFromKey(key) {
    var p = String(key || '').split('|');
    if (p.length !== 2) return 'that guard';
    return p[0].charAt(0).toUpperCase() + p[0].slice(1) + ' ' + p[1];
  }

  function guardsMap() { return (window.CardGuard || {}).guards || {}; }

  function keyForVariant(variantId) {
    var g = guardsMap();
    for (var k in g) {
      if (g.hasOwnProperty(k) && String(g[k].id) === String(variantId)) return k;
    }
    return null;
  }

  /* Guards in one cart line or add payload, as { "black|PSA": 10 }. Pack
     contents win: a pack line's own variant is the pack, not a guard. */
  function guardsIn(props, variantId, quantity) {
    var out = {}, qty = quantity || 1, found = false;
    if (props) {
      for (var k in props) {
        if (!props.hasOwnProperty(k) || String(k).charAt(0) === '_') continue;
        if (!/^Guard\s/i.test(k)) continue;
        var key = guardKey(props[k]);
        if (key) { out[key] = (out[key] || 0) + qty; found = true; }
      }
    }
    if (found) return out;
    /* A free guard is the guard it stands for */
    var fg = guardByFreeId(variantId);
    var vk = keyForVariant(fg ? fg.id : variantId);
    if (vk) out[vk] = qty;
    return out;
  }

  function guardsInCart(cart) {
    var out = {};
    if (!cart || !cart.items) return out;
    cart.items.forEach(function (item) {
      var one = guardsIn(item.properties, item.variant_id, item.quantity);
      for (var k in one) if (one.hasOwnProperty(k)) out[k] = (out[k] || 0) + one[k];
    });
    return out;
  }

  /* How many more of a guard the cart can still take. null = untracked. */
  function guardHeadroom(key, cart) {
    var info = guardsMap()[key];
    if (!info || typeof info.stock !== 'number') return null;
    return Math.max(0, info.stock - (guardsInCart(cart || lastCart)[key] || 0));
  }

  /* "Only N left" once the shopper is close to clearing us out. Counts every
     line of the guard — a chosen free guard ships from the same stock. */
  function stockNoteHtml(variantId) {
    var left = stockLeft(variantId);
    if (left === null) return '';
    var remaining = left - inCartQty(variantId);
    if (remaining > 2) return '';
    if (remaining <= 0) return '<div class="cart-stock-note maxed">That’s all ' + left + ' we have in stock</div>';
    return '<div class="cart-stock-note">Only ' + remaining + ' more left in stock</div>';
  }

  /* The rows the drawer last drew, so a button can find every line key
     behind the row it sits on. */
  var shownRows = [];

  /* noFix: show this cart exactly as it is, without putting it in shape
     first (used when putting it in shape just failed). */
  function renderCart(cart, noFix) {
    lastCart = cart;
    document.dispatchEvent(new CustomEvent('cg:cart', { detail: cart }));
    /* Every 6th guard free, the dearest first: a cart that isn't in that
       shape is fixed first and the fixed cart is what gets drawn. */
    if (!noFix && autoNormalize(cart)) return;
    var els = cartEls();
    if (!els.items) return;

    renderShipProgress(cart);
    renderDeal(cart);

    if (els.count) {
      if (cart.item_count > 0) {
        els.count.style.display = 'flex';
        els.count.textContent = cart.item_count;
      } else {
        els.count.style.display = 'none';
      }
    }

    if (cart.items.length === 0) {
      shownRows = [];
      els.items.innerHTML = emptyCartHtml();
      if (els.footer) els.footer.style.display = 'none';
      return;
    }

    var view = dealView(cart);
    var beat = codeBeatsDeal(cart);
    shownRows = view.rows;

    els.items.innerHTML = view.rows.map(function (row, idx) {
      var item = row.item;
      var g = row.g;
      /* "Black Guard — BGS" reads as the name on one line and the fit on the
         line under it, the way a Prism guard already shows its PSA fit; and
         the fit is just "PSA" / "BGS", not "PSA Case" (user, 2026-09-19). */
      var lineName, sub;
      if (g && g.name) {
        lineName = g.name;
        sub = escapeHtml(g.fit || '');
      } else {
        /* The OG titles end in " Slab Display Case" for search and AI agents
           (2026-10-26); the drawer keeps showing the short name. */
        var titleParts = String(item.product_title || '').replace(/ Slab Display Case/g, '').split(' — ');
        lineName = titleParts[0];
        sub = titleParts[1]
          ? escapeHtml(titleParts[1].trim())
          : (item.variant_title && item.variant_title !== 'Default Title' ? escapeHtml(item.variant_title) : '');
      }

      var src = isPick(item) ? (g && g.img) : cartImageFor(item);
      if (!src && g) src = g.img;
      var img = src ? '<img src="' + src + '" alt="" loading="lazy" onerror="this.style.display=\'none\'">' : '';

      var stockId = g ? g.id : item.variant_id;
      var left = stockLeft(stockId);
      var atMax = left !== null && inCartQty(stockId) >= left;

      /* Line money is line-level discounts only — the deal. A code is an
         order discount: it never lowers a line, it shows in the saving line
         under the subtotal instead. */
      var wasPrice = row.was;
      var otherOff = Math.max(0, (row.was - row.now) - row.deal);
      var nowPrice = Math.max(0, row.was - row.deal - otherOff);
      var freeUnits = row.unit ? Math.round(row.deal / row.unit) : 0;
      var allFree = nowPrice === 0 && wasPrice > 0;
      var cut = wasPrice > nowPrice;
      if (freeUnits > 0) sub += (sub ? ' ' : '') + '<span class="cart-free-tag">' + (allFree && freeUnits === 1 ? 'Free guard' : freeUnits + ' FREE') + '</span>';

      var priceHtml = allFree
        ? '<s class="cart-item-was">' + formatMoney(wasPrice) + '</s> <span class="cart-item-free">FREE</span>'
        : (cut ? '<s class="cart-item-was">' + formatMoney(wasPrice) + '</s> ' : '') + formatMoney(nowPrice);

      var pillHtml = (!allFree && !freeUnits && otherOff > 0)
        ? '<div class="cart-item-off">' + Math.round(otherOff / wasPrice * 100) + '% off</div>'
        : '';

      var eachHtml = (!cut && row.quantity > 1)
        ? '<div class="cart-item-each">' + formatMoney(item.original_price) + ' each</div>'
        : '';

      /* A free unit that is being charged: only ever because a code beat
         the deal, and it says so. */
      var noteHtml = (row.freeLineQty > freeUnits && beat)
        ? '<div class="cart-free-note">The FREE guard is charged while code ' + escapeHtml(beat) + ' is applied — the two don’t stack</div>'
        : '';

      var qtyHtml = '<div class="cart-qty">' +
          '<button type="button" class="cart-qty-btn" data-row="' + idx + '" data-qty="' + (row.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
          '<input type="number" class="cart-qty-input" data-row="' + idx + '" data-original="' + row.quantity + '" value="' + row.quantity + '"' +
            ' min="0" step="1"' + (left !== null ? ' max="' + left + '"' : '') + ' inputmode="numeric" aria-label="Quantity">' +
          '<button type="button" class="cart-qty-btn" data-row="' + idx + '" data-qty="' + (row.quantity + 1) + '"' +
            (atMax ? ' disabled title="No more in stock"' : '') + ' aria-label="Increase quantity">+</button>' +
        '</div>';

      return '<div class="cart-item' + (freeUnits > 0 ? ' is-pick' : '') + '">' +
        '<div class="cart-item-swatch">' + img + '</div>' +
        '<div class="cart-item-info">' +
          '<div class="cart-item-name">' + escapeHtml(lineName) + '</div>' +
          (sub ? '<div class="cart-item-sub">' + sub + '</div>' : '') +
          qtyHtml +
          stockNoteHtml(stockId) +
          noteHtml +
        '</div>' +
        '<div class="cart-item-right">' +
          '<div class="cart-item-price">' + priceHtml + '</div>' +
          pillHtml +
          eachHtml +
          '<button type="button" class="cart-item-remove" data-row="' + idx + '" data-line-key="' + escapeHtml(row.keys[0]) + '"' +
            ' aria-label="Remove ' + escapeHtml(lineName) + '">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');

    els.items.querySelectorAll('.cart-item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = shownRows[parseInt(btn.getAttribute('data-row'), 10)];
        if (row) changeRow(row, 0);
      });
    });

    els.items.querySelectorAll('.cart-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = shownRows[parseInt(btn.getAttribute('data-row'), 10)];
        if (row) changeRow(row, Math.max(0, parseInt(btn.getAttribute('data-qty'), 10) || 0));
      });
    });

    els.items.querySelectorAll('.cart-qty-input').forEach(function (input) {
      // Type a number straight in rather than clicking + ten times.
      // Only commit on blur/Enter so a re-render can't yank focus mid-typing.
      input.addEventListener('focus', function () { input.select(); });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); input.blur(); }
        else if (e.key === 'Escape') {
          input.value = input.getAttribute('data-original');
          input.blur();
        }
      });

      input.addEventListener('blur', function () { commitQty(input); });
    });

    if (els.total) els.total.textContent = formatMoney(itemsTotal(cart));
    var sp = shipParts(cart);
    [['cart-ship-add', 'add'], ['cart-page-ship-add', 'add']].forEach(function (t) {
      var el = document.getElementById(t[0]);
      if (el) el.innerHTML = sp[t[1]];
    });
    renderCartDiscounts(cart);
    renderCodeBox(cart);
    renderPageCode(cart);
    if (els.footer) els.footer.style.display = 'block';
    /* The footer can change height as it is redrawn (the saving line comes
       and goes); a message on screen moves with it, so it never sits over
       the code box or Checkout. */
    var toast = document.getElementById('toast');
    if (toast && toast.classList.contains('show')) placeToast(toast);
    maybeOfferFree(cart);
  }

  /* ── A code the shopper already holds ──
     A code won on the wheel, or carried in on an ad's /discount/CODE link,
     used to be invisible until checkout: the drawer priced everything at full
     rate while checkout quietly took 15% off. Shopify applies a /discount link
     to the cart itself, so that case already shows up in cart_level_discount_
     applications; the wheel only ever SHOWED its code. Now the win is kept
     under cgCode and pushed onto the cart with /cart/update.js (Ajax API,
     May 2025), so every total in the drawer has it taken off before checkout
     (user, 2026-09-19). A cart that already carries a code is left alone -
     the discount parameter replaces the set, and an ad's code must not be
     swapped out from under the shopper. */
  var CODE_KEY = 'cgCode';
  var codeAttempt = '';
  function storedCode() {
    try { return (localStorage.getItem(CODE_KEY) || '').trim().toUpperCase(); } catch (e) { return ''; }
  }
  function cartCodes(cart) {
    var out = [];
    (cart.discount_codes || []).forEach(function (d) { if (d && d.code) out.push(String(d.code).toUpperCase()); });
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      if (a && a.discount_application) a = a.discount_application;
      if (a.type === 'discount_code' && a.title) out.push(String(a.title).toUpperCase());
    });
    return out;
  }
  /* What a wheel code is worth, from its name: SPIN10 … SPIN25 */
  function prizePct(code) {
    var m = /(\d+)$/.exec(String(code || ''));
    return m ? parseInt(m[1], 10) : 0;
  }
  function withCode(cart) {
    var code = storedCode();
    if (!cart || !cart.items || !code || !cart.item_count) return Promise.resolve(cart);
    /* On the cart already, working or waiting its turn */
    if (cartCodes(cart).indexOf(code) !== -1) return Promise.resolve(cart);
    /* Another code already working on this cart (an ad's /discount link,
       usually CARDGUARD15): the prize only takes its place when it is worth
       more. A code Shopify is NOT using (applicable: false) never blocks the
       prize — it used to, so a shopper carrying a dead code was told their
       prize was applied when it never was. */
    var held = appliedCode(cart);
    if (held && !(prizePct(code) > codePct(cart, held))) return Promise.resolve(cart);
    /* One try per code per cart state. A code the cart won't take yet (a
       minimum spend, a used-up cap) gets another go when the cart changes,
       not a request on every render. */
    var stamp = code + ':' + cart.item_count + ':' + cart.total_price;
    if (codeAttempt === stamp) return Promise.resolve(cart);
    codeAttempt = stamp;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    })
      .then(function (r) { return r.ok ? r.json() : cart; })
      .then(function (c) { return (c && c.items) ? c : cart; })
      .catch(function () { return cart; });
  }
  /* spin-logic fires this the moment a prize lands, and hears back what came
     of it (cg:code-result): the prize on the cart, a code already there kept
     because it saves at least as much, or (dead) the prize sitting on the
     cart unused because Buy 5 Get 1 FREE saves more — the wheel said
     "Applied … 15% off" over a cart the free guard had won. */
  document.addEventListener('cg:code', function () {
    codeAttempt = '';
    refreshCart().then(function (cart) {
      var code = storedCode();
      if (!cart || !code) return;
      var held = appliedCode(cart);
      var unused = (cart.discount_codes || []).some(function (d) {
        return d && String(d.code).toUpperCase() === code && d.applicable === false;
      });
      document.dispatchEvent(new CustomEvent('cg:code-result', {
        detail: { code: code, kept: held && held !== code ? held : '', dead: unused && dealView(cart).total > 0 }
      }));
    });
  });

  /* ── Discount code entry in the drawer ──
     A code from an ad lands on the cart by itself (the /discount link) and a
     wheel win is pushed on by withCode() below, but a shopper who has a code
     from a post, a friend or an email had nowhere to type it before checkout,
     and the drawer priced everything at full rate until then (user,
     2026-09-21: "customers can see discounted price ... without moving over
     to checkout"). This box is the entry field when the cart carries no code,
     and turns into a "CODE applied" chip when it does — whichever way the
     code got there. Removing the chip clears cgCode too, or withCode() would
     put the wheel's code straight back. */
  var codeUiKey = '';
  /* Whether the shopper opened "Have a discount code?" this visit, so a re-render keeps it open */
  var codeBoxOpen = false;
  function appliedCode(cart) {
    var codes = cartCodes(cart);
    /* discount_codes carries applicable; a code Shopify accepted but cannot
       use on this cart is not "applied" and must not be shown as such. */
    var dead = {};
    (cart.discount_codes || []).forEach(function (d) {
      if (d && d.code && d.applicable === false) dead[String(d.code).toUpperCase()] = true;
    });
    for (var i = 0; i < codes.length; i++) if (!dead[codes[i]]) return codes[i];
    return '';
  }
  /* A code sitting on the cart that Shopify is not using — usually a wheel
     code on a cart where Buy 5 Get 1 FREE is worth more. It is left on the
     cart on purpose: it switches back on by itself if the cart shrinks, or
     grows to where it saves more (codeMode then takes the FREE line out). */
  function deadCode(cart) {
    var list = cart.discount_codes || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i] && list[i].code && list[i].applicable === false) return String(list[i].code).toUpperCase();
    }
    return '';
  }
  function codePct(cart, code) {
    var apps = cart.cart_level_discount_applications || [];
    for (var i = 0; i < apps.length; i++) {
      var a = apps[i]; if (a && a.discount_application) a = a.discount_application;
      if (a.type === 'discount_code' && String(a.title).toUpperCase() === code && a.value_type === 'percentage' && parseFloat(a.value)) return parseFloat(a.value);
    }
    return 0;
  }
  /* The chip for a code on the cart: applied, or sitting there unused */
  function codeChipHtml(cart, code, dead) {
    var name = code || dead;
    var pct = code ? codePct(cart, code) : 0;
    /* FREEGUARD rode in on old emails as a /discount link. The deal it
       stood for is automatic now, so say that rather than "not valid". */
    var what = code ? 'applied' + (pct ? ' &middot; ' + pct + '% off' : '')
      : dead === 'FREEGUARD' ? 'not needed — Buy 5 Get 1 FREE is automatic'
      : (dealView(cart).total > 0 ? 'not used — the free guard saves more' : 'not valid for this cart');
    return '<div class="cart-code-applied' + (dead ? ' is-dead' : '') + '" role="status">' +
      (code ? '<span class="cart-code-tick" aria-hidden="true">&#10003;</span>' : '') +
      '<span class="cart-code-name">' + escapeHtml(name) + '</span>' +
      '<span class="cart-code-what">' + what + '</span>' +
      '<button type="button" class="cart-code-remove" aria-label="Remove code ' + escapeHtml(name) + '">Remove</button>' +
      '</div>';
  }
  /* /cart: its code box is Liquid, and Liquid only sees codes that are
     applied, so a code the free guard beat just vanished there — the empty
     box read as "my ad code was lost" — while the drawer explained it. The
     same chip goes in here, and Remove reloads the page as the rest of it
     does. */
  function renderPageCode(cart) {
    var host = document.getElementById('cart-page-code');
    if (!host || !cart || !cart.item_count || appliedCode(cart)) return;
    var dead = deadCode(cart);
    if (!dead || host.getAttribute('data-cg-dead') === dead) return;
    host.setAttribute('data-cg-dead', dead);
    host.innerHTML = codeChipHtml(cart, '', dead);
    host.querySelector('.cart-code-remove').addEventListener('click', function () {
      var btn = this;
      btn.disabled = true; btn.textContent = 'Removing…';
      window.cgRemoveCode(dead).then(function () { window.location.reload(); });
    });
  }
  function renderCodeBox(cart) {
    var host = document.getElementById('cart-code');
    if (!host) return;
    if (!cart || !cart.item_count) { host.innerHTML = ''; codeUiKey = ''; return; }
    var code = appliedCode(cart);
    var dead = code ? '' : deadCode(cart);
    var dealOn = dealView(cart).total > 0;
    var key = code ? 'on:' + code + ':' + codePct(cart, code)
      : dead ? 'dead:' + dead + ':' + dealOn
      : 'off:' + dealOn;
    /* Same state as last time: leave the markup alone so a half-typed code
       and the caret survive the re-render a quantity change triggers. */
    if (key === codeUiKey && host.firstChild) return;
    /* Still the entry field, but the free guard came or went: the answer
       to the last Apply ("… Buy 5 Get 1 FREE may already save you more") is
       about a cart that's gone, so it goes too. It stayed up after the
       free guard had gone, when the code would have won. */
    if (!code && !dead && /^off:/.test(codeUiKey) && host.querySelector('.cart-code-row')) {
      codeUiKey = key;
      var stale = host.querySelector('.cart-code-err');
      if (stale) stale.remove();
      return;
    }
    codeUiKey = key;

    if (code || dead) {
      var name = code || dead;
      host.innerHTML = codeChipHtml(cart, code, dead);
      host.querySelector('.cart-code-remove').addEventListener('click', function () {
        var btn = this;
        btn.disabled = true; btn.textContent = 'Removing…';
        window.cgRemoveCode(name).then(function (res) {
          if (res && res.ok) return;
          /* It used to sit on "Removing…" until the page was reloaded */
          codeUiKey = '';
          renderCodeBox(lastCart);
          showToast((res && res.error) || 'That didn’t go through — try again.');
        });
      });
      return;
    }

    /* The pill field and Apply button (user, 2026-09-28: "I liked the old
       enter code display ... it just took up too much room"), now behind a
       "Have a discount code?" link (owner, 2026-10-26: an empty box sends
       shoppers off hunting for a code, and with the Meta CARDGUARD15 ads off
       nobody needs it in their face). Wheel wins and /discount links still
       apply themselves and show as the chip above; this is for codes typed
       from a pamphlet or an eBay insert. That a code and the free guard don't
       stack is said when it matters, in the answer to Apply. */
    host.innerHTML =
      '<details class="cart-code-more"' + (codeBoxOpen ? ' open' : '') + '>' +
      '<summary class="cart-code-toggle">Have a discount code?</summary>' +
      '<form class="cart-code-row" novalidate>' +
      '<input class="cart-code-input" type="text" inputmode="text" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="Discount code" aria-label="Discount code">' +
      '<button type="submit" class="cart-code-btn">Apply</button>' +
      '</form>' +
      '</details>';
    var more = host.querySelector('details');
    /* Opened and focused inside the tap itself: iOS only raises the keyboard
       for a focus() made during the tap, and the toggle event comes after it */
    more.querySelector('summary').addEventListener('click', function (e) {
      if (more.open) return;
      e.preventDefault();
      more.open = true;
      var f = more.querySelector('input'); if (f) f.focus();
    });
    more.addEventListener('toggle', function () { codeBoxOpen = more.open; });
    var form = host.querySelector('form');
    /* Enter in the field submits — belt and braces for the odd embedded
       browser that does not route Enter to the form's submit button. */
    form.querySelector('input').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); form.dispatchEvent(new Event('submit', { cancelable: true })); }
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input'), btn = form.querySelector('button');
      var val = String(input.value || '').trim().toUpperCase();
      var old = host.querySelector('.cart-code-err'); if (old) old.remove();
      if (!val) { input.focus(); return; }
      btn.disabled = true; btn.textContent = 'Applying…';
      window.cgApplyCode(val).then(function (res) {
        if (res.ok) return; /* renderCart has swapped this for the chip */
        btn.disabled = false; btn.textContent = 'Apply';
        var err = document.createElement('div');
        err.className = 'cart-code-err';
        err.textContent = res.error;
        (host.querySelector('details') || host).appendChild(err);
        input.focus(); input.select();
      });
    });
  }
  /* Both return a promise of {ok, error, cart}. The cart page calls them too
     and reloads itself, since its lines are server-rendered. */
  window.cgApplyCode = function (code) {
    code = String(code || '').trim().toUpperCase();
    var fail = function (msg) { return { ok: false, error: msg }; };
    /* FREEGUARD was the Buy 5 Get 1 code in emails and ads before the deal
       went automatic (2026-09-28). Anyone still holding it gets told they
       don't need it, rather than "invalid". */
    if (code === 'FREEGUARD') {
      return Promise.resolve(fail('No code needed — Buy 5 Get 1 FREE applies by itself. Add 6 guards and the most expensive one is FREE.'));
    }
    return queueCart(function () { return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return fail('That didn’t go through — try again.');
        var entry = (cart.discount_codes || []).filter(function (d) { return d && String(d.code).toUpperCase() === code; })[0];
        var applied = entry ? entry.applicable !== false : cartCodes(cart).indexOf(code) > -1;
        if (applied) {
          codeAttempt = '';
          renderCart(cart);
          return { ok: true, cart: cart };
        }
        /* With the free guard on, Shopify answers a code that loses to it
           and a code that doesn't exist the same way (applicable: false), so
           the answer covers both — a mistyped code used to be told the deal
           beat it, and the shopper never learnt it was a typo. */
        var dealOn = dealView(cart).total > 0;
        /* Shopify keeps an unusable code on the cart and would carry it into
           checkout as an error there. Take it back off so the cart is clean. */
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: '' })
        })
          .then(function (r) { return r.ok ? r.json() : cart; })
          .then(function (c) {
            renderCart((c && c.items) ? c : cart);
            return fail(dealOn
              ? 'We couldn’t apply ' + code + ' — check the spelling, or Buy 5 Get 1 FREE may already save you more.'
              : 'That code isn’t valid for this cart.');
          });
      })
      .catch(function () { return fail('That didn’t go through — try again.'); }); });
  };
  /* which: the code being taken off. The wheel's prize (cgCode) is only
     forgotten when it is the one removed — taking an ad's code off used to
     throw the prize away with it — and with another code gone, the prize goes
     on in its place. No code named (the "Use FREE guard" swap) clears both. */
  window.cgRemoveCode = function (which) {
    var forget = !which || String(which).trim().toUpperCase() === storedCode();
    if (forget) { try { localStorage.removeItem(CODE_KEY); } catch (e) {} }
    /* A /discount/CODE link also leaves Shopify's own discount_code cookie
       behind; drop it too, or checkout could put the code straight back. */
    try { document.cookie = 'discount_code=; Max-Age=0; path=/'; } catch (e) {}
    codeAttempt = '';
    return queueCart(function () { return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' })
    })
      .then(function (r) { if (!r.ok) throw new Error('remove'); return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) throw new Error('remove');
        return forget ? cart : withCode(cart);
      })
      .then(function (cart) { renderCart(cart); return { ok: true, cart: cart }; })
      .catch(function () { return { ok: false, error: 'That didn’t go through — try again.' }; }); });
  };


  /* Read the cart and draw it. Only from inside a queued task; anywhere
     else, refreshCart(). */
  function loadCart() {
    return fetchCart()
      .then(migrateLegacyPicks)
      .then(withCode)
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { return null; });
  }
  function refreshCart() { return queueCart(loadCart); }

  function commitQty(input) {
    if (input.dataset.committing === '1') return;
    var prev = parseInt(input.getAttribute('data-original'), 10);
    var raw = String(input.value).trim();
    var next = parseInt(raw, 10);
    // Blank, junk or negative — put it back rather than emptying the cart.
    if (raw === '' || isNaN(next) || next < 0) { input.value = prev; return; }
    if (next === prev) { input.value = prev; return; }
    var row = shownRows[parseInt(input.getAttribute('data-row'), 10)];
    if (!row) { input.value = prev; return; }
    /* Typed past stock: no more than there is, paid and free units
       together — a free unit ships from the guard's own stock. Only the +
       button was capped; typing 9 Ruby (8 in stock) put 7 + 2 FREE in. */
    var capped = '';
    var left = row.g && next > prev ? stockLeft(row.g.id) : null;
    if (left !== null && next > left) {
      capped = 'Only ' + left + ' of ' + row.g.name + ' left in stock';
      next = Math.max(left, prev);
      input.value = next;
      if (next === prev) { showToast(capped); return; }
    }
    input.dataset.committing = '1';
    changeRow(row, next, capped);
  }

  /* Set a drawer row to a quantity. For a guard that is its total — paid and
     free together — and the free units are worked out again for the whole
     cart (normalizePlan), so one request both changes the quantity and keeps
     every 6th guard free. Any other row: the first line takes the quantity,
     the rest go to zero. */
  var changing = false;
  function rowsBusy(on) {
    var items = document.getElementById('cart-items');
    if (items) items.classList.toggle('is-busy', !!on);
  }
  function rowBySig(cart, sig) {
    var found = null;
    dealView(cart).rows.forEach(function (r) { if (r.sig === sig) found = r; });
    return found;
  }
  /* capped: the stock message when commitQty brought a typed number down */
  function changeRow(row, quantity, capped) {
    if (changing) return;
    /* An increase is the shopper moving towards the deal, so the "next guard
       is FREE" picker may open once the cart comes back. A decrease never
       arms it. */
    var up = quantity > row.quantity;
    if (up) dealArmed = true;
    changing = true;
    rowsBusy(true);
    queueCart(function () {
      /* Planned now, from the cart as it is, not as it was drawn */
      var before = lastCart;
      var updates = null;
      if (row.g) {
        var totals = {};
        totals[String(row.g.id)] = quantity;
        updates = normalizePlan(before, totals);
      } else {
        var cur = rowBySig(before, row.sig);
        if (cur) {
          updates = {};
          cur.keys.forEach(function (k, i) { updates[k] = i === 0 ? quantity : 0; });
        }
      }
      if (!updates) { renderCart(before, true); return; }
      return jpost('/cart/update.js', { updates: updates })
        .then(withCode)
        .then(function (cart) {
          renderCart(cart);
          announceFreeChange(before, cart);
          /* Said last, so it is the message left on screen: it is why the
             number isn't the one they typed */
          if (capped) { showToast(capped); return; }
          /* Shopify quietly caps a line at whatever's in stock. Say so —
             otherwise the + button just looks broken. */
          if (up) {
            var after = row.g ? null : rowBySig(cart, row.sig);
            var got = row.g ? (heldByGuard(cart)[row.g.id] || 0) : (after ? after.quantity : 0);
            if (got < quantity) {
              showToast('Only ' + got + ' of ' + ((row.g && row.g.name) || String(row.item.product_title || 'this guard').replace(/ Slab Display Case/g, '')) + ' left in stock');
            }
          }
        });
    }).then(function () {
      changing = false;
      rowsBusy(false);
    }, function (e) {
      changing = false;
      rowsBusy(false);
      showToast((e && e.description) || 'Something went wrong — try again');
      refreshCart();
    });
  }

  /* How many of this guard the cart holds, on every line — including free
     units, which ship (and take stock) as the guard they stand for. */
  function inCartQty(variantId) {
    if (!lastCart || !lastCart.items) return 0;
    var n = 0;
    lastCart.items.forEach(function (i) {
      var g = isPick(i) ? guardByFreeId(i.variant_id) : null;
      if (String(g ? g.id : i.variant_id) === String(variantId)) n += i.quantity;
    });
    return n;
  }

  function addOne(payload, label) {
    var want = payload.quantity || 1;

    /* Stop the add before it leaves the browser when we already know there
       isn't the stock for it. Shopify would reject a loose guard anyway, but
       its wording is generic — and it would happily accept a pack, because the
       pack has its own inventory and the guards inside it are only properties.
       Counting the guards ourselves is the only thing standing between a
       6-in-stock guard and a 10-pack of it. */
    var wanted = guardsIn(payload.properties, payload.id, want);
    for (var key in wanted) {
      if (!wanted.hasOwnProperty(key)) continue;
      var room = guardHeadroom(key);
      if (room === null || wanted[key] <= room) continue;
      var name = guardNameFromKey(key);
      showDrawer();
      showToast(room === 0
        ? 'No ' + name + ' guards left — your cart already has them all'
        : 'Only ' + room + ' ' + name + ' guard' + (room === 1 ? '' : 's') + ' left in stock');
      return loadCart();
    }

    /* Anything tracked that isn't a guard still gets the plain variant check */
    var left = stockLeft(payload.id);
    if (left !== null && !keyForVariant(payload.id)) {
      var have = inCartQty(payload.id);
      if (have + want > left) {
        showDrawer();
        showToast(have >= left
          ? 'That’s all ' + left + ' we have in stock'
          : 'Only ' + (left - have) + ' more left in stock');
        return loadCart();
      }
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function () {
      /* Resolve only once the cart has been read back, so the next queued add
         sees this one's quantity instead of a stale count. The drawer opens
         before the message so the message lands in it (placeToast). */
      dealArmed = true;
      showDrawer();
      showToast((label || 'Item') + ' added to cart');
      return loadCart();
    }).catch(function (e) {
      showToast((e && e.description) || 'Could not add to cart');
      return loadCart();
    });
  }

  /* Read the cart once on load so the very first click is checked against what
     the shopper already has, not against an empty cart. Without this the guard
     only kicks in from the second add onwards. A cart that isn't in shape (an
     old-style free guard, or a change made on the /cart page) is put in shape
     here; the /cart page's lines are Liquid, so that page then reloads. */
  function cartSig(cart) {
    return ((cart && cart.items) || []).map(function (i) { return i.key + ':' + i.quantity; }).join('|');
  }
  /* On /cart: the cart the page's Liquid lines were drawn from */
  var pageCartSig = null;
  document.addEventListener('DOMContentLoaded', function () {
    if (!document.getElementById('cart-items')) return;
    var onCartPage = !!document.querySelector('.cart-page');
    if (onCartPage) window.cgCartPageReady = true;
    queueCart(function () {
      return fetchCart()
        .then(function (cart) {
          var sig0 = cartSig(cart);
          if (onCartPage) pageCartSig = sig0;
          return migrateLegacyPicks(cart)
            .then(normalizeNow)
            .then(function (c) {
              lastCart = c;
              document.dispatchEvent(new CustomEvent('cg:cart', { detail: c }));
              if (cartSig(c) !== sig0) {
                /* At most one reload in a few seconds: a cart Shopify keeps
                   changing back must not become a reload loop. */
                var recent = false;
                try {
                  recent = Date.now() - Number(sessionStorage.getItem('cgCartReload') || 0) < 5000;
                  if (!recent) sessionStorage.setItem('cgCartReload', String(Date.now()));
                } catch (e) { recent = true; }
                if (onCartPage && !recent) { window.location.reload(); return; }
                renderCart(c, true);
                return;
              }
              var pageDeal = document.getElementById('cart-page-deal');
              if (pageDeal) renderDeal(c, pageDeal);
              renderPageCode(c);
              /* In shape by now unless Shopify refused the move: say so
                 here too (the deal line above offers another go) */
              if (onCartPage && freeOwed(c) > freeUnitsNow(dealView(c))) showToast(FREE_FAIL);
            });
        })
        .catch(function () {});
    });
  });

  window.cgAddToCart = function (payload, label) {
    /* Adds run one at a time, in the one cart queue. Clicking "Add to cart"
       twice quickly used to fire two concurrent /cart/add.js calls; each read
       the cart before the other had committed, so both passed the stock check
       and a guard with one left in stock could land in the cart twice. */
    return queueCart(function () { return addOne(payload, label); });
  };

  /* ── Bundles: a pair or a six in one tap (2026-10-03) ──
     A bundle is not a product. It is real guards added together in one
     request, so they land as the ordinary guard lines a shopper would have
     built by hand: stock, Buy 5 Get 1 FREE (a six comes back with its
     dearest guard on the FREE Guard line, through renderCart's
     autoNormalize) and the free shipping count all behave exactly as for
     single adds, and checkout, the receipt and the packing slip show nothing
     new. The stock check is addOne's, summed over the whole bundle first, so
     a six can't half-arrive: it goes in whole or not at all.
     items: [{ id, quantity }], each a real guard variant. */
  function addBundle(items, label) {
    var wanted = {}, plain = {};
    items.forEach(function (it) {
      var one = guardsIn(null, it.id, it.quantity), keyed = false;
      for (var k in one) {
        if (!one.hasOwnProperty(k)) continue;
        wanted[k] = (wanted[k] || 0) + one[k];
        keyed = true;
      }
      if (!keyed) plain[String(it.id)] = (plain[String(it.id)] || 0) + it.quantity;
    });
    for (var key in wanted) {
      if (!wanted.hasOwnProperty(key)) continue;
      var room = guardHeadroom(key);
      if (room === null || wanted[key] <= room) continue;
      var name = guardNameFromKey(key);
      showDrawer();
      showToast(room === 0
        ? 'No ' + name + ' guards left — your cart already has them all'
        : 'Only ' + room + ' ' + name + ' guard' + (room === 1 ? '' : 's') + ' left in stock');
      return loadCart();
    }
    for (var id in plain) {
      if (!plain.hasOwnProperty(id)) continue;
      var left = stockLeft(id);
      if (left === null) continue;
      var have = inCartQty(id);
      if (have + plain[id] > left) {
        showDrawer();
        showToast(have >= left
          ? 'That’s all ' + left + ' we have in stock'
          : 'Only ' + (left - have) + ' more left in stock');
        return loadCart();
      }
    }
    return jpost('/cart/add.js', { items: items }).then(function () {
      dealArmed = true;
      showDrawer();
      showToast((label || 'Bundle') + ' added to cart');
      return loadCart();
    }).catch(function (e) {
      showToast((e && e.description) || 'Could not add to cart');
      return loadCart();
    });
  }

  window.cgAddBundle = function (items, label) {
    var list = (items || []).map(function (it) {
      return { id: Number(it && it.id), quantity: Math.max(1, parseInt(it && it.quantity, 10) || 1) };
    }).filter(function (it) { return it.id > 0; });
    if (!list.length) return Promise.resolve(null);
    return queueCart(function () { return addBundle(list, label); });
  };

  /* One listener for every bundle button on any page: the guards as JSON in
     data-cg-bundle, the name for the message in data-cg-bundle-label
     (sections/bundle-shop, snippets/pair-it). A second tap while the first
     is still working is ignored — on a six that would be twelve guards. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-cg-bundle]') : null;
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    var items;
    try { items = JSON.parse(btn.getAttribute('data-cg-bundle') || '[]'); } catch (err) { return; }
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    function done() { btn.removeAttribute('aria-busy'); }
    window.cgAddBundle(items, btn.getAttribute('data-cg-bundle-label') || '').then(done, done);
  });

  /* ── Free-guard picker ──
     "Congratulations, you've unlocked a free guard" (user, 2026-09-28): a
     modal of guard cards with confetti, one tap per free guard, no code.
     Built on first use and reused. Ways in (opts.mode):
       * auto     — the cart holds 5 (11, 17…) guards, so the next one in is
                    FREE. Opens by itself once a visit, straight after the
                    shopper's own add, and from "Choose it" in the drawer any
                    time. Adding a guard any other way works just as well —
                    the dearest guard in the cart goes FREE regardless.
       * tile     — the product page's Buy 5 / Buy 10 tiles (cgBuyWithFree).
                    Opens FIRST, then adds the paid guards and the free ones
                    in one request, so the cart never shows a half-done state.
       * checkout — Checkout pressed one guard short of a free one. Picks or
                    passes, then carries on to checkout (opts.onDone).
     Any guard can be picked, OG or Prism, any mix, the same guard more than
     once while stock lasts. A pick goes in as the FREE Guard variant for that
     guard; if the cart holds a dearer guard, that one becomes the free one
     instead (normalizePlan — same guards, lower price). */
  var fp = null;
  var fpState = null;

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function confetti(canvas) {
    if (!canvas || !canvas.getContext || reducedMotion()) return;
    var box = canvas.parentNode.getBoundingClientRect();
    var w = box.width, h = box.height;
    if (!w || !h) return;
    var dpr = window.devicePixelRatio || 1;
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(h * dpr);
    var ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    var colours = ['#d9ad42', '#f1d27a', '#ffffff', '#b82020', '#1a7a42', '#2563a8', '#d4548f', '#c9992e'];
    var bits = [];
    for (var i = 0; i < 120; i++) {
      var side = i % 2 ? 1 : -1;
      bits.push({
        x: w / 2 + side * (w * 0.18) * Math.random(),
        y: h * 0.22,
        vx: side * (1 + Math.random() * 6) * (Math.random() < 0.3 ? -0.4 : 1),
        vy: -(4 + Math.random() * 8),
        sw: 5 + Math.random() * 5,
        sh: 8 + Math.random() * 7,
        r: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.35,
        c: colours[i % colours.length]
      });
    }
    var start = 0, LIFE = 2400;
    function frame(t) {
      if (!start) start = t;
      var age = t - start;
      ctx.clearRect(0, 0, w, h);
      if (age > LIFE || !fp || !fp.classList.contains('open')) return;
      ctx.globalAlpha = Math.max(0, 1 - age / LIFE);
      bits.forEach(function (b) {
        b.vy += 0.26; b.vx *= 0.985;
        b.x += b.vx; b.y += b.vy; b.r += b.vr;
        ctx.save();
        ctx.translate(b.x, b.y);
        ctx.rotate(b.r);
        ctx.fillStyle = b.c;
        ctx.fillRect(-b.sw / 2, -b.sh / 2, b.sw, b.sh * Math.abs(Math.cos(b.r * 2)) + 1);
        ctx.restore();
      });
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function buildPicker() {
    if (fp) return fp;
    fp = document.createElement('div');
    fp.id = 'cg-free';
    fp.className = 'cgf';
    fp.setAttribute('role', 'dialog');
    fp.setAttribute('aria-modal', 'true');
    fp.setAttribute('aria-labelledby', 'cgf-title');
    fp.innerHTML =
      '<div class="cgf-box">' +
        '<canvas class="cgf-confetti" aria-hidden="true"></canvas>' +
        '<button type="button" class="cgf-close" aria-label="Close">&#10005;</button>' +
        '<p class="cgf-eyebrow"></p>' +
        '<h2 class="cgf-title" id="cgf-title"></h2>' +
        '<p class="cgf-sub"></p>' +
        '<button type="button" class="cgf-reset" hidden>Start again</button>' +
        '<div class="cgf-grid"></div>' +
        '<p class="cgf-foot"></p>' +
        '<p class="cgf-err" role="alert"></p>' +
        '<button type="button" class="cgf-later">Maybe later</button>' +
      '</div>';
    document.body.appendChild(fp);
    fp.addEventListener('click', function (e) { if (e.target === fp) closeFreePicker(true); });
    fp.querySelector('.cgf-close').addEventListener('click', function () { closeFreePicker(true); });
    fp.querySelector('.cgf-later').addEventListener('click', function () {
      if (fpState && fpState.busy) return;
      /* In checkout mode the button is "No thanks, go to checkout" */
      var done = fpState && fpState.mode === 'checkout' ? fpState.onDone : null;
      closeFreePicker(true);
      if (done) done();
    });
    fp.querySelector('.cgf-reset').addEventListener('click', function () {
      if (!fpState || fpState.busy) return;
      fpState.chosen = [];
      renderPickCards();
    });
    fp.querySelector('.cgf-grid').addEventListener('click', function (e) {
      var card = e.target && e.target.closest ? e.target.closest('.cgf-card') : null;
      if (!card || card.disabled || !fpState || fpState.busy) return;
      choosePick(card.getAttribute('data-id'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && fp.classList.contains('open')) closeFreePicker(true);
    });
    return fp;
  }

  function closeFreePicker(dismissed) {
    if (!fp) return;
    /* ✕, Escape or a tap outside while the pick is being added: ignored.
       Closing then cancelled the trip to checkout (the guard still went in),
       and on /cart left the rows stale; the pick finishes and carries on
       where it was going in a moment anyway. */
    if (dismissed && fpState && fpState.busy) return;
    fp.classList.remove('open', 'is-busy', 'is-done');
    document.body.style.overflow = '';
    /* "Maybe later" on the cart's own offer: not again at this number of
       paid guards. A tile's picker closing just means the tile wasn't used. */
    if (dismissed && fpState && fpState.mode !== 'tile') dealDismissedAt = guardQty(lastCart);
    fpState = null;
    syncExpress(lastCart);
  }

  var SERIES_NAME = { og: 'OG', prism: 'Prism' };

  /* The cards, redrawn after every pick: stock left depends on what has been
     chosen so far. Each card says what picking it really does (pickVerdict):
     FREE; its price and which dearer guard goes FREE instead; or, when a
     code on the cart still beats the deal for it, its price and why — that
     card can't be picked, as nothing would be free. */
  function renderPickCards() {
    var s = fpState;
    var counts = {};
    s.chosen.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
    /* While the pick goes in the cards keep what they said: every pick is
       made by then, so "the next one" means nothing */
    var list = s.busy ? s.list : pickOptions(s.cart, s.extra, s.chosen).map(function (o) {
      o.v = o.room > 0 ? pickVerdict(s, o.g) : {};
      return o;
    });
    s.list = list;
    fp.querySelector('.cgf-grid').innerHTML = list.map(function (o) {
      var g = o.g, c = counts[g.id] || 0;
      var v = o.v || {};
      var pct = v.code ? codePct(s.cart, v.code) : 0;
      var price = v.code
        ? '<span class="cgf-price">' + formatMoney(g.price) + '</span>' +
          '<span class="cgf-fit cgf-note">' + (pct ? 'Your ' + pct + '% code' : 'Code ' + escapeHtml(v.code)) + ' saves more</span>'
        : v.instead
          ? '<span class="cgf-price">' + formatMoney(g.price) + '</span>' +
            '<span class="cgf-fit cgf-note">Your ' + escapeHtml(v.instead.name) + ' goes FREE</span>'
          : '<span class="cgf-price"><s>' + formatMoney(g.price) + '</s><b>FREE</b></span>';
      return '<button type="button" class="cgf-card' + (c ? ' is-chosen' : '') + '" data-id="' + g.id + '"' +
          (o.room < 1 || v.code ? ' disabled' : '') + ' style="--sw:' + escapeHtml(g.swatch || '#222') + '">' +
        '<span class="cgf-img">' +
          (g.img ? '<img src="' + escapeHtml(g.img) + '" alt="" loading="lazy">' : '') +
          (c ? '<span class="cgf-badge">' + (c > 1 ? c + '&times; ' : '') + '&#10003;</span>' : '') +
        '</span>' +
        '<span class="cgf-name">' + escapeHtml(g.name) + '</span>' +
        '<span class="cgf-fit">' + (SERIES_NAME[g.series] || 'OG') + ' &middot; ' + escapeHtml(g.fit) + '</span>' +
        price +
      '</button>';
    }).join('');
    if (s.need > 1 && !s.busy) {
      var left = s.need - s.chosen.length;
      fp.querySelector('.cgf-sub').textContent = s.chosen.length
        ? 'Great pick! Now choose your ' + (left === 1 ? 'last' : 'next') + ' FREE guard.'
        : s.subText;
    }
    fp.querySelector('.cgf-reset').hidden = !(s.need > 1 && s.chosen.length > 0 && !s.busy);
  }

  /* opts: { count, cart, extra: { id, qty, label }, mode, onDone } */
  window.cgOpenFreePicker = function (opts) {
    opts = opts || {};
    var cart = opts.cart || lastCart || { items: [] };
    var need = Math.max(1, opts.count || DEAL.get);
    var mode = opts.mode || (opts.extra ? 'tile' : 'auto');
    buildPicker();
    fpState = { need: need, chosen: [], cart: cart, extra: opts.extra || null, list: [], busy: false,
      subText: '', mode: mode, onDone: opts.onDone || null };

    var many = need > 1;
    var eyebrow = many ? 'Buy ' + (DEAL.buy * need) + ' Get ' + need + ' FREE' : DEAL.title;
    var title, sub;
    if (mode === 'tile') {
      var eg = guardById(opts.extra.id);
      var what = opts.extra.qty + ' × ' + (eg ? eg.name + ' (' + eg.fit + ')' : (opts.extra.label || 'guards'));
      title = many ? 'Now choose your <em>' + need + ' FREE</em> guards' : 'Now choose your <em>FREE</em> guard';
      sub = many
        ? 'Choose ' + need + ' more guards to go with your ' + what + ' — mix OG and Prism however you like. The ' + need + ' most expensive in your cart go FREE. No code needed.'
        : 'Choose one more guard to go with your ' + what + ' — OG or Prism. The most expensive guard in your cart goes FREE. No code needed.';
    } else if (mode === 'checkout') {
      eyebrow = 'Before you check out';
      title = 'Don’t forget — your next guard is <em>FREE</em>!';
      sub = 'Choose one more guard — OG or Prism. The most expensive guard in your cart goes FREE, then it’s on to checkout.';
    } else {
      title = 'Congratulations! Your next guard is <em>FREE</em>';
      sub = 'Choose one more guard — OG or Prism. The most expensive guard in your cart goes FREE. No code needed.';
    }
    fpState.subText = sub;

    fp.querySelector('.cgf-eyebrow').textContent = eyebrow;
    fp.querySelector('.cgf-title').innerHTML = title;
    fp.querySelector('.cgf-sub').textContent = sub;
    fp.querySelector('.cgf-err').textContent = '';
    fp.querySelector('.cgf-foot').textContent = 'Adding a guard any other way works too — the most expensive guard in your cart is always the FREE one.';
    fp.querySelector('.cgf-later').textContent = mode === 'tile' ? 'Cancel'
      : mode === 'checkout' ? 'No thanks, go to checkout' : 'Maybe later';
    renderPickCards();
    if (!fpState.list.some(function (o) { return o.room > 0; })) {
      fp.querySelector('.cgf-sub').textContent = 'Every guard is sold out right now — sorry.';
    }
    fp.classList.remove('is-busy', 'is-done');
    fp.classList.add('open');
    document.body.style.overflow = 'hidden';
    var box = fp.querySelector('.cgf-box');
    if (box) box.scrollTop = 0;
    setTimeout(function () {
      confetti(fp.querySelector('.cgf-confetti'));
      var first = fp.querySelector('.cgf-card:not([disabled])') || fp.querySelector('.cgf-close');
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
    }, 60);
  };

  function choosePick(id) {
    var s = fpState;
    s.chosen.push(id);
    if (s.chosen.length < s.need) { renderPickCards(); return; }
    commitPicks();
  }

  /* The paid guards (a tile's) and the free ones, in one /cart/add.js */
  function pickItems(s) {
    var items = [];
    if (s.extra) items.push({ id: Number(s.extra.id), quantity: s.extra.qty });
    var counts = {}, order = [];
    s.chosen.forEach(function (id) { if (!counts[id]) order.push(id); counts[id] = (counts[id] || 0) + 1; });
    order.forEach(function (id) {
      var g = guardById(id);
      if (g && g.freeId) items.push({ id: Number(g.freeId), quantity: counts[id] });
    });
    return items;
  }

  function commitPicks() {
    var s = fpState;
    s.busy = true;
    fp.classList.add('is-busy');
    renderPickCards();
    var items = pickItems(s);
    var counts = {}, order = [];
    s.chosen.forEach(function (id) { if (!counts[id]) order.push(id); counts[id] = (counts[id] || 0) + 1; });
    var names = order.map(function (id) {
      var g = guardById(id);
      var n = g ? g.name + ' (' + g.fit + ')' : 'guard';
      return counts[id] > 1 ? counts[id] + ' × ' + n : n;
    });
    var paidG = s.extra ? guardById(s.extra.id) : null;

    return queueCart(function () {
      var before = lastCart;
      return jpost('/cart/add.js', { items: items })
        .then(function () {
          /* Straight into shape: a pick can make a dearer guard already in
             the cart the free one instead. Done before checkout or the
             drawer, so neither sees it half-done. */
          return fetchCart().then(normalizeNow).then(function (c) {
            if (c && c.items) lastCart = c;
          }, function () {});
        })
        .then(function () {
          if (!fpState) {
            if (document.querySelector('.cart-page')) { window.location.reload(); return; }
            return loadCart();
          }
          fp.classList.remove('is-busy');
          fp.classList.add('is-done');
          /* Worded from what Shopify did with the pick, not what was hoped:
             FREE only if units really went free, naming the guard that did —
             the dearest, which can be one already in the cart (a Clear picked
             into a cart of Rubies goes in at $29.95 and a Ruby goes free). */
          var after = lastCart;
          var was = freeByGuard(before), now = freeByGuard(after);
          var won = sumOf(now) - sumOf(was) >= s.chosen.length;
          var elsewhere = [], many = false;
          guardGroups(after).forEach(function (grp) {
            var gain = (now[grp.g.id] || 0) - (was[grp.g.id] || 0);
            if (gain <= 0 || counts[grp.g.id]) return;
            elsewhere.push(gain > 1 ? gain + ' ' + grp.g.name + 's' : grp.g.name);
            if (gain > 1) many = true;
          });
          many = many || elsewhere.length > 1;
          var code = won ? '' : (codeWinning(after) || appliedCode(after));
          var what = (s.extra
            ? s.extra.qty + ' × ' + (paidG ? paidG.name + ' (' + paidG.fit + ')' : 'guards') + (won && !elsewhere.length ? ' + FREE ' : ' + ')
            : '') + names.join(' + ') + ' added. ' +
            (won
              ? (elsewhere.length ? 'Your ' + elsewhere.join(' + ') + (many
                  ? ' are the FREE ones — the most expensive guards in your cart always are. '
                  : ' is the FREE one — the most expensive guard in your cart always is. ') : '')
              : code ? 'Your code ' + code + ' saves more than a FREE guard here, so that’s the one applied. '
              : freeOwed(after) > freeUnitsNow(dealView(after)) ? FREE_FAIL + ' from your cart. '
              : '');
          var plural = s.chosen.length > 1;
          fp.querySelector('.cgf-eyebrow').textContent = 'Added to your cart';
          fp.querySelector('.cgf-reset').hidden = true;
          if (s.mode === 'checkout') {
            fp.querySelector('.cgf-title').innerHTML = won ? 'Your <em>FREE</em> guard' + (plural ? 's are' : ' is') + ' in!' : 'Added to your cart';
            fp.querySelector('.cgf-sub').textContent = what + 'Taking you to checkout…';
          } else {
            fp.querySelector('.cgf-title').innerHTML = won ? 'Your <em>FREE</em> guard' + (plural ? 's are' : ' is') + ' in your cart' : 'Added to your cart';
            fp.querySelector('.cgf-sub').textContent = what.trim();
          }
          if (won) confetti(fp.querySelector('.cgf-confetti'));
          dealDismissedAt = -1;
          var done = s.mode === 'checkout' ? s.onDone : null;
          return new Promise(function (res) { setTimeout(res, done ? 900 : 1300); }).then(function () {
            closeFreePicker(false);
            if (done) { done(); return; }
            if (document.querySelector('.cart-page')) { window.location.reload(); return; }
            showDrawer();
            return loadCart();
          });
        })
        .catch(function (e) {
          if (!fpState) return loadCart();
          s.busy = false;
          s.chosen = [];
          fp.classList.remove('is-busy');
          return fetchCart().then(function (c) {
            if (fpState) { fpState.cart = c; renderPickCards(); }
            renderCart(c);
          }, function () {}).then(function () {
            if (fpState) fp.querySelector('.cgf-err').textContent = (e && e.description) || 'That didn’t go through — try again.';
          });
        });
    });
  }

  /* Product-page tiles: "Buy 5, get 1 FREE" / "Buy 10, get 2 FREE". Checks
     stock for the paid guards first, then opens the picker with them pending.
     The picker asks for as many free guards as keep every 6th guard free
     once the tile's guards are in (a cart already holding 5 gets 2 with a
     Buy 5). If there is nothing to pick from, or an applied code would beat
     the deal, the paid guards simply go in the normal way — and the dearest
     guard still goes FREE by itself when the count allows. */
  /* A tile tapped twice while its first tap is still working is ignored —
     where the paid guards go straight in (a code that beats the deal), a
     double tap added 10 more guards. */
  var tileBusy = false;
  window.cgBuyWithFree = function (variantId, qty, free, label) {
    if (tileBusy) return;
    tileBusy = true;
    function release() { tileBusy = false; }
    variantId = Number(variantId);
    function go(cart) {
      var left = stockLeft(variantId);
      if (left !== null) {
        var have = inCartQty(variantId);
        if (have + qty > left) {
          release();
          showDrawer();
          showToast(have >= left
            ? 'That’s all ' + left + ' we have in stock'
            : 'Only ' + (left - have) + ' more left in stock');
          return refreshCart();
        }
      }
      var extra = { id: variantId, qty: qty, label: label };
      /* How many free guards come with this tile: as many as keep every 6th
         guard free once the tile's paid guards and the free ones are in. */
      var n = guardQty(cart), f0 = freeFor(n), count = 0;
      while (freeFor(n + qty + count + 1) - f0 >= count + 1) count++;
      var best = count ? bestFreePick(pickOptions(cart, extra)) : null;
      /* A code that beats the deal whichever guard is picked: no picker */
      var blocked = !best || (appliedCode(cart) && !anyPickFree(cart, extra, count));
      if (blocked) return window.cgAddToCart({ id: variantId, quantity: qty }, label).then(release, release);
      release();
      window.cgOpenFreePicker({ count: count, cart: cart, extra: extra, mode: 'tile' });
    }
    /* After anything already under way, from the cart it leaves */
    return queueCart(function () {
      return lastCart || fetchCart().then(function (c) { lastCart = c; return c; });
    }).then(go, function () { go(lastCart || { items: [] }); });
  };

  document.addEventListener('click', function (e) {
    var dropdown = document.getElementById('cart-dropdown');
    var btn = document.querySelector('.nav-cart-btn');
    /* A tap that re-rendered its own target (the code toggle, a picker card)
       leaves e.target detached, which would read as "outside the drawer".
       And the free-guard picker sits over the drawer: a tap in it is not a
       tap outside the cart either. */
    if (!e.target || !document.documentElement.contains(e.target)) return;
    if (fp && fp.contains(e.target)) return;
    if (cartOpen && dropdown && !dropdown.contains(e.target) && btn && !btn.contains(e.target)) {
      window.closeCart();
    }
  });

  /* ── Notify modal ── */
  window.openNotifyModal = function () {
    var m = document.getElementById('notify-modal');
    if (!m) return;
    m.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      var input = document.getElementById('notify-email');
      if (input) input.focus();
    }, 300);
  };

  window.closeNotifyModal = function (e) {
    var m = document.getElementById('notify-modal');
    if (!m) return;
    if (e && e.target !== m) return;
    m.classList.remove('open');
    document.body.style.overflow = '';
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var m = document.getElementById('notify-modal');
      if (m) m.classList.remove('open');
      var w = document.getElementById('welcome-modal');
      if (w && w.classList.contains('open')) window.dismissWelcomeModal(false);
      document.body.style.overflow = '';
      window.closeCart();
    }
  });

  /* ── Welcome popup (5% off signup) ── */
  var WELCOME_DISMISS_DAYS = 7;

  window.dismissWelcomeModal = function (done) {
    var w = document.getElementById('welcome-modal');
    if (w) w.classList.remove('open');
    document.body.style.overflow = '';
    if (done) {
      localStorage.setItem('cgWelcomeDone', '1');
    } else {
      localStorage.setItem('cgWelcomeDismissedAt', String(Date.now()));
    }
  };

  window.copyWelcomeCode = function () {
    var codeBtn = document.querySelector('#welcome-modal .welcome-code');
    var hint = document.getElementById('welcome-code-hint');
    if (!codeBtn) return;
    var code = codeBtn.textContent.trim();
    function ok() { if (hint) hint.textContent = 'Copied!'; }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(ok).catch(function () {});
    }
  };

  function initWelcomePopup() {
    var w = document.getElementById('welcome-modal');
    if (!w) return;

    var form = document.getElementById('welcome-form');
    if (form) {
      form.addEventListener('submit', function () {
        localStorage.setItem('cgWelcomePending', '1');
      });
    }

    // Returning from a successful signup: show the code
    if (window.location.search.indexOf('customer_posted=true') !== -1 && localStorage.getItem('cgWelcomePending')) {
      localStorage.removeItem('cgWelcomePending');
      localStorage.setItem('cgWelcomeDone', '1');
      var fs = document.getElementById('welcome-form-state');
      var ss = document.getElementById('welcome-success-state');
      if (fs) fs.style.display = 'none';
      if (ss) ss.style.display = 'block';
      w.classList.add('open');
      document.body.style.overflow = 'hidden';
      return;
    }
    localStorage.removeItem('cgWelcomePending');

    // Click outside closes (counts as dismiss)
    w.addEventListener('click', function (e) {
      if (e.target === w) window.dismissWelcomeModal(false);
    });

    // ── Targeting ────────────────────────────────────────────────
    // Already subscribed, recently dismissed, or already seen this visit
    if (localStorage.getItem('cgWelcomeDone')) return;
    var dismissedAt = parseInt(localStorage.getItem('cgWelcomeDismissedAt'), 10) || 0;
    if (Date.now() - dismissedAt < WELCOME_DISMISS_DAYS * 86400000) return;
    try { if (sessionStorage.getItem('cgWelcomeSeen')) return; } catch (e) {}

    // Pages where we never interrupt (cart, checkout, account, contact, search…)
    var tier = w.getAttribute('data-tier') || 'browse';
    if (tier === 'off') return;

    var highIntent = tier === 'high';
    var delay = parseInt(w.getAttribute(highIntent ? 'data-delay-product' : 'data-delay-browse'), 10) || 15000;
    var scrollPct = highIntent ? 0.35 : 0.5;
    var useExitIntent = w.getAttribute('data-exit-intent') === 'true' &&
      window.matchMedia && window.matchMedia('(min-width: 769px)').matches;

    var fired = false;
    var timer = null;

    function teardown() {
      if (timer) { clearTimeout(timer); timer = null; }
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onExitIntent);
    }

    function show() {
      if (fired) return;
      /* Never over the colour-waitlist modal, the open cart or the free-guard
         picker — wait and try again. Over the cart it opened dimmed behind
         the overlay on desktop, and spent the visit's one showing doing it. */
      var inWay = ['notify-modal', 'cart-dropdown', 'cg-free'].some(function (id) {
        var el = document.getElementById(id);
        return !!(el && el.classList.contains('open'));
      });
      if (inWay) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(show, 8000);
        return;
      }
      fired = true;
      teardown();
      try { sessionStorage.setItem('cgWelcomeSeen', '1'); } catch (e) {}
      w.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    // Trigger 1 — engaged time on page
    timer = setTimeout(show, delay);

    // Trigger 2 — read far enough down to show real interest
    function onScroll() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && (window.pageYOffset / max) >= scrollPct) show();
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    // Trigger 3 — about to leave (desktop only; mobile has no reliable signal)
    function onExitIntent(e) {
      if (!e.relatedTarget && e.clientY <= 0) show();
    }
    if (useExitIntent) document.addEventListener('mouseout', onExitIntent);
  }

  document.addEventListener('DOMContentLoaded', initWelcomePopup);

  /* ── Reviews carousel (dots + arrows, swipe on touch) ── */
  function initReviewsCarousel() {
    document.querySelectorAll('[data-reviews-track]').forEach(function (track) {
      var section = track.closest('.reviews-section');
      if (!section) return;
      var nav = section.querySelector('[data-reviews-nav]');
      if (!nav) return;

      var dotsWrap = nav.querySelector('[data-reviews-dots]');
      var arrows = nav.querySelectorAll('.reviews-arrow');
      var cards = Array.prototype.slice.call(track.querySelectorAll('.review-card'));
      if (cards.length < 2) { nav.style.display = 'none'; return; }

      // one dot per card
      var dots = cards.map(function (card, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'reviews-dot' + (i === 0 ? ' active' : '');
        d.setAttribute('aria-label', 'Review ' + (i + 1));
        d.addEventListener('click', function () {
          track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(d);
        return d;
      });

      function activeIndex() {
        var best = 0, bestDist = Infinity;
        cards.forEach(function (c, i) {
          var dist = Math.abs((c.offsetLeft - track.offsetLeft) - track.scrollLeft);
          if (dist < bestDist) { bestDist = dist; best = i; }
        });
        return best;
      }

      function sync() {
        var idx = activeIndex();
        dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
        var maxScroll = track.scrollWidth - track.clientWidth;
        arrows.forEach(function (a) {
          var dir = parseInt(a.getAttribute('data-dir'), 10);
          a.disabled = dir < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= maxScroll - 2;
        });
        // nothing to scroll — hide the controls entirely
        nav.style.display = maxScroll <= 2 ? 'none' : '';
      }

      arrows.forEach(function (a) {
        a.addEventListener('click', function () {
          var dir = parseInt(a.getAttribute('data-dir'), 10);
          var step = cards[0].getBoundingClientRect().width + 20;
          track.scrollBy({ left: dir * step, behavior: 'smooth' });
        });
      });

      var ticking;
      track.addEventListener('scroll', function () {
        clearTimeout(ticking);
        ticking = setTimeout(sync, 60);
      }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }
  document.addEventListener('DOMContentLoaded', initReviewsCarousel);

  /* ── Quick add to cart on product cards ── */
  function initQuickAdd() {
    document.querySelectorAll('[data-quickadd]').forEach(function (wrap) {
      var cases = wrap.querySelectorAll('.qa-case');
      var addBtn = wrap.querySelector('.qa-add');
      if (!addBtn || !cases.length) return;

      /* Null until the shopper picks — no case is preselected, so either one
         can be chosen first and show its clip. */
      function selected() {
        for (var i = 0; i < cases.length; i++) {
          if (cases[i].classList.contains('active')) return cases[i];
        }
        return null;
      }

      var caseNames = [];
      cases.forEach(function (c) {
        var l = (c.getAttribute('data-label') || '').trim();
        if (l) caseNames.push(l);
      });
      var choosePrompt = caseNames.length ? 'Choose ' + caseNames.join(' or ') : 'Choose an option';

      /* Every case type gone. Prompting for a choice that leads nowhere reads
         as available until the shopper clicks, so say it up front instead. */
      var anyAvailable = false;
      cases.forEach(function (c) {
        if (c.getAttribute('data-available') === 'true') anyAvailable = true;
      });

      function sync() {
        var s = selected();
        if (!anyAvailable) {
          addBtn.disabled = true;
          addBtn.classList.remove('needs-choice');
          addBtn.textContent = 'Sold out';
          return;
        }
        if (!s) {
          addBtn.disabled = true;
          addBtn.textContent = choosePrompt;
          addBtn.classList.add('needs-choice');   // a prompt, not a dead end — keep it legible
          return;
        }
        addBtn.classList.remove('needs-choice');
        var ok = s.getAttribute('data-available') === 'true';
        addBtn.disabled = !ok;
        addBtn.textContent = ok ? 'Add to cart' : 'Sold out';
      }

      /* Toggling the case swaps the card photo and plays that guard's clip,
         mirroring the product page. Nothing loads until the shopper clicks. */
      var card = wrap.closest('.product-card');
      var cardImg = card ? card.querySelector('.card-photo') : null;
      var cardVideo = card ? card.querySelector('.card-video') : null;
      var handle = wrap.getAttribute('data-handle') || '';
      /* Checked per click, not once at init — the window may have been resized since load */
      function mq(q) { return window.matchMedia ? window.matchMedia(q).matches : false; }

      function settle() {
        if (!cardVideo) return;
        cardVideo.pause();
        cardVideo.classList.remove('playing');
      }

      function showCase(btn) {
        /* Each option's clip plays once only. Coming back to an option the
           shopper has already seen — even one they cut short by switching
           away — goes straight to the still photo. */
        var clip = GUARD_VIDEOS[handle + '|' + (btn.getAttribute('data-label') || '').trim()];
        var willPlay = !!clip && cardVideo &&
                       btn.getAttribute('data-played') !== '1' &&
                       !mq('(prefers-reduced-motion: reduce)');

        /* The still takes about a second to fetch, so it is decoded off-screen
           first. Swapping early would leave the card blank in the gap. */
        var url = btn.getAttribute('data-img');
        var photoReady = !(cardImg && url);
        var settleWhenReady = false;

        if (cardImg && url) {
          var pre = new Image();
          pre.onload = pre.onerror = function () {
            /* srcset would override src, so it has to go */
            cardImg.removeAttribute('srcset');
            cardImg.removeAttribute('sizes');
            cardImg.src = url;
            photoReady = true;
            if (!willPlay || settleWhenReady) settle();
          };
          pre.src = url;
        }

        if (!willPlay) {
          if (photoReady) settle();   // nothing to load — reveal the still now
          return;
        }

        btn.setAttribute('data-played', '1');
        function done() { if (photoReady) { settle(); } else { settleWhenReady = true; } }

        cardVideo.setAttribute('poster', clip.poster);
        cardVideo.setAttribute('src', (mq('(max-width: 768px)') ? clip.sd : clip.hd) || clip.hd);
        cardVideo.classList.add('playing');
        cardVideo.load();
        var p = cardVideo.play();
        if (p && p.catch) p.catch(done);
        cardVideo.onended = done;
        cardVideo.onerror = done;
      }

      cases.forEach(function (c) {
        c.addEventListener('click', function (e) {
          e.preventDefault();
          if (c.classList.contains('active')) return;   // already showing — don't replay
          cases.forEach(function (o) { o.classList.remove('active'); });
          c.classList.add('active');
          sync();
          showCase(c);
        });
      });

      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var s = selected();
        if (!s || s.getAttribute('data-available') !== 'true') return;
        /* Nothing on screen changes until the add comes back, so a second
           tap used to add a second guard */
        if (addBtn.getAttribute('aria-busy') === 'true') return;
        addBtn.setAttribute('aria-busy', 'true');
        addBtn.textContent = 'Adding…';
        var title = (addBtn.getAttribute('data-product-title') || 'Guard').replace(/ Slab Display Case/g, '');
        var label = s.getAttribute('data-label');
        function done() { addBtn.removeAttribute('aria-busy'); sync(); }
        window.cgAddToCart(
          { id: parseInt(s.getAttribute('data-variant-id'), 10), quantity: 1 },
          label ? title + ' — ' + label + ' Case' : title
        ).then(done, done);
      });

      sync();
    });
  }
  document.addEventListener('DOMContentLoaded', initQuickAdd);

  /* ── Accordions (Description / Delivery / Returns) ── */
  function initAccordions() {
    document.querySelectorAll('[data-accordion] .pp-acc-head').forEach(function (head) {
      var item = head.parentNode;
      var panel = item.querySelector('.pp-acc-panel');

      head.addEventListener('click', function () {
        var open = item.classList.toggle('open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        // Drive the height explicitly — no arbitrary max-height cap, and it
        // keeps working regardless of how the panel is nested.
        if (panel) panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      });

      // Keep an open panel correctly sized if the viewport changes
      window.addEventListener('resize', function () {
        if (panel && item.classList.contains('open')) panel.style.maxHeight = panel.scrollHeight + 'px';
      });
    });
  }
  document.addEventListener('DOMContentLoaded', initAccordions);

  /* ── Mobile menu ── */
  window.toggleMobileMenu = function () {
    var menu = document.getElementById('mobile-menu');
    var burger = document.getElementById('nav-burger');
    if (!menu) return;
    var open = menu.classList.toggle('open');
    if (burger) {
      burger.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  };

  window.closeMobileMenu = function () {
    var menu = document.getElementById('mobile-menu');
    var burger = document.getElementById('nav-burger');
    if (menu) menu.classList.remove('open');
    if (burger) { burger.classList.remove('open'); burger.setAttribute('aria-expanded', 'false'); }
  };

  document.addEventListener('click', function (e) {
    var menu = document.getElementById('mobile-menu');
    var burger = document.getElementById('nav-burger');
    if (menu && menu.classList.contains('open') && !menu.contains(e.target) && burger && !burger.contains(e.target)) {
      window.closeMobileMenu();
    }
  });

  /* ── Hero carousel ── */
  function initHeroCarousel(root) {
    var slides = root.querySelectorAll('.hero-slide');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('.hero-dot');
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var current = 0;
    var timer;

    /* Videos carry their sources as data attributes so nothing downloads until
       a slide is actually needed — otherwise all four would fetch on load. */
    var wantSd = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function videoIn(i) {
      return slides[i] ? slides[i].querySelector('.hero-slide-video') : null;
    }

    function load(i) {
      var v = videoIn(i);
      if (!v || v.getAttribute('src')) return v;
      var src = (wantSd ? v.getAttribute('data-sd') : v.getAttribute('data-hd')) || v.getAttribute('data-hd');
      if (src) { v.setAttribute('src', src); v.load(); }
      return v;
    }

    /* Image slides after the first arrive with their pictures as data
       attributes (sections/hero, LAZY SLIDES), so the first screen downloads
       one slide rather than four. hydrate() puts a slide's pictures in place;
       ready() also waits for the one this screen paints, so a slide never
       fades in as an empty dark panel on a slow connection - capped at 4s so
       a failed image can't stall the carousel. */
    function hydrate(s) {
      if (!s || !s.hasAttribute('data-lazy')) return;
      s.removeAttribute('data-lazy');
      var wide = s.getAttribute('data-wide');
      if (wide) s.style.setProperty('--wide', 'url("' + wide + '")');
      [].forEach.call(s.querySelectorAll('[data-bg]'), function (el) {
        el.style.backgroundImage = 'url("' + el.getAttribute('data-bg') + '")';
        var full = el.getAttribute('data-full');
        if (full) el.style.setProperty('--full', 'url("' + full + '")');
      });
    }

    function ready(i, cb) {
      var s = slides[i];
      hydrate(s);
      var img = s && s.querySelector('.hero-slide-img[data-bg]');
      var url = !img ? '' : wantSd ? img.getAttribute('data-bg') : (s.getAttribute('data-wide') || img.getAttribute('data-full'));
      if (!url) { cb(); return; }
      var done = false;
      var finish = function () { if (!done) { done = true; cb(); } };
      var pic = new Image();
      pic.onload = pic.onerror = finish;
      pic.src = url;
      setTimeout(finish, 4000);
    }

    /* One slide ahead, and only once the page itself has loaded, so the next
       picture never competes with the first (the LCP image). */
    function warm(i) {
      if (document.readyState === 'complete') ready(i, function () {});
      else window.addEventListener('load', function () { ready(i, function () {}); }, { once: true });
    }

    /* Every change of slide goes through here: wait for the picture, then
       show it - unless a later request (a dot) has superseded this one. */
    var wanted = 0;
    function go(i) {
      i = (i + slides.length) % slides.length;
      wanted = i;
      ready(i, function () { if (wanted === i) show(i); });
    }

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) {
        s.classList.toggle('active', idx === current);
        var v = s.querySelector('.hero-slide-video');
        if (v && idx !== current) { try { v.pause(); v.currentTime = 0; } catch (e) {} }
      });
      dots.forEach(function (d, idx) { d.classList.toggle('active', idx === current); });

      clearTimeout(timer);
      clearInterval(timer);

      var vid = load(current);
      if (vid && !reduceMotion) {
        var p = vid.play();
        /* Autoplay can still be refused (low-power mode, data saver) — fall
           back to the poster frame and keep the carousel moving on a timer. */
        if (p && p.catch) p.catch(function () { timer = setTimeout(next, interval); });
      } else {
        timer = setTimeout(next, interval);
      }

      load(current + 1 < slides.length ? current + 1 : 0);   // warm the next clip
      warm(current + 1 < slides.length ? current + 1 : 0);   // and the next picture
    }

    function next() { go(current + 1); }

    slides.forEach(function (s) {
      var v = s.querySelector('.hero-slide-video');
      if (!v) return;
      v.addEventListener('ended', next);
      v.addEventListener('error', function () { clearTimeout(timer); timer = setTimeout(next, interval); });
    });

    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-slide'), 10)); });
    });

    /* Don't burn bandwidth or battery on a tab nobody's looking at */
    document.addEventListener('visibilitychange', function () {
      var v = videoIn(current);
      if (!v) return;
      if (document.hidden) { try { v.pause(); } catch (e) {} }
      else if (!reduceMotion) { try { v.play(); } catch (e) {} }
    });

    show(0);
  }

  /* ── Carousel dots (mobile only — these grids scroll horizontally there) ──
     Shared by the Why and Pricing sections. Pair a track with its
     dots by giving both the same name. */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (track) {
      var name = track.getAttribute('data-carousel');
      var dotWrap = document.querySelector('[data-carousel-dots="' + name + '"]');
      if (dotWrap) initCarousel(track, dotWrap);
    });
  }

  function initCarousel(track, dotWrap) {
    var dots = [].slice.call(dotWrap.querySelectorAll('.carousel-dot'));
    var cells = [].slice.call(track.children);
    if (!dots.length || !cells.length) return;

    function nearest() {
      /* Compare centres — the cards are centre-snapped, so the middle of the
         viewport is what the shopper is actually looking at. */
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestGap = Infinity;
      cells.forEach(function (c, i) {
        var gap = Math.abs((c.offsetLeft + c.offsetWidth / 2) - mid);
        if (gap < bestGap) { bestGap = gap; best = i; }
      });
      return best;
    }

    function sync() {
      var idx = nearest();
      dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
    }

    /* A handful of cells — measuring them directly is cheap enough that
       throttling through rAF only adds a way for the dots to stall. */
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        var c = cells[i];
        if (!c) return;
        track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' });
      });
    });

    sync();
  }

  /* ── Product page (PSA/BGS toggle drives variant + image) ── */
  document.addEventListener('DOMContentLoaded', function () {
    initCarousels();
    var pp = document.querySelector('[data-product-json]');
    if (pp) initProductPage(pp);
    var hero = document.querySelector('[data-hero-carousel]');
    if (hero) initHeroCarousel(hero);
  });

  function initProductPage(root) {
    var product;
    try { product = JSON.parse(root.querySelector('[data-product-json-script]').textContent); } catch (e) { return; }
    var toggle = root.querySelector('.pp-case-toggle');
    var addBtn = root.querySelector('.pp-add-btn');
    var priceEl = root.querySelector('.pp-price');
    var img = root.querySelector('.pp-stage img') || root.querySelector('.pp-visual > img');
    var thumbs = root.querySelectorAll('.pp-thumb');
    var selectedVariant = product.variants[0];
    /* Which case the gallery is currently showing — drives both the thumbnail
       filter and which photos the supporting tiles are allowed to pull */
    var currentCase = '';

    /* ── Intro clip: plays once per case, then dissolves onto the still ── */
    var stageVideo = root.querySelector('.pp-stage-video');
    /* Case labels whose clip has already been started this visit */
    var playedCases = {};
    /* Read per call, not once at load — the window may have been resized since */
    function mq(q) { return window.matchMedia ? window.matchMedia(q).matches : false; }

    function settleVideo() {
      if (!stageVideo) return;
      try { stageVideo.pause(); } catch (e) {}
      stageVideo.classList.remove('playing');
    }

    /* The variant JSON gives the untouched original (2048px). Handing that
       straight to the <img> after dropping srcset blew the grid row out on
       phones, so always ask the CDN for a sensible width. */
    function sizedImg(src, w) {
      if (!src || /[?&]width=/.test(src)) return src;
      return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
    }

    function playIntro() {
      if (!stageVideo || mq('(prefers-reduced-motion: reduce)')) return;
      /* Clear and Black are single-variant products, so the raw option is the
         literal "Default Title", never "PSA"/"BGS" — every GUARD_VIDEOS lookup
         missed and the intro clip was silently skipped. Same trap that made
         packs order as "Clear — Default Title Case" before the tiles were
         changed to add real guard variants. */
      var caseType = (selectedVariant.option1 || selectedVariant.title || '').trim();
      if (!caseType || /^default title$/i.test(caseType)) { caseType = fitFromHandle(); }
      var clip = GUARD_VIDEOS[(product.handle || '') + '|' + caseType];
      if (!clip) { settleVideo(); return; }
      /* Each case's clip plays once per visit. Switching to BGS and back to PSA
         lands straight on the still — same rule as the homepage cards, and it
         counts a clip the shopper cut short by switching away as seen. */
      if (playedCases[caseType]) { settleVideo(); return; }
      playedCases[caseType] = true;

      var src = (mq('(max-width: 768px)') ? clip.sd : clip.hd) || clip.hd;

      /* Show the clip's own opening frame straight away. Revealing the video
         only after it buffers is what made the still visible first and caused
         the jump — the poster covers that window with the exact frame the
         clip starts on, so there's nothing to see loading. */
      stageVideo.setAttribute('poster', clip.poster);
      stageVideo.setAttribute('src', src);
      stageVideo.classList.add('playing');
      stageVideo.load();

      var p = stageVideo.play();
      if (p && p.catch) p.catch(settleVideo);

      stageVideo.onended = settleVideo;
      stageVideo.onerror = settleVideo;
    }

    /* ── Back-in-stock capture, only while the selection is sold out ── */
    var notifyWrap = root.querySelector('[data-pp-notify]');
    var restockTag = notifyWrap && notifyWrap.querySelector('[data-restock-tag]');

    var notifyBody = notifyWrap && notifyWrap.querySelector('[data-notify-body]');

    /* "Clear" + "PSA" — reads the way a collector would say it. The split
       products carry a single "Default Title" variant, so the fit comes from
       the handle (-psa / -bgs); the old option1 read gave "Black Default
       Title" in the restock line (audit, 2026-09-19). */
    function fitFromHandle() {
      var m = /-(psa|bgs)$/i.exec(product.handle || '');
      return m ? m[1].toUpperCase() : '';
    }
    function guardName() {
      var colour = (product.title || '').split(' ')[0];
      var caseType = (selectedVariant.option1 || selectedVariant.title || '').trim();
      if (!caseType || caseType === 'Default Title') { caseType = fitFromHandle(); }
      return (colour + ' ' + caseType).trim() || 'This guard';
    }

    function updateNotify() {
      if (!notifyWrap) return;
      var sold = !selectedVariant.available;
      notifyWrap.hidden = !sold;
      if (!sold) return;
      if (restockTag) {
        /* e.g. restock-clear-guard-psa — tells you which guard to email */
        var ct = (selectedVariant.option1 || selectedVariant.title || '').trim().toLowerCase();
        /* The handle already ends in the fit for the split products */
        if (ct === 'default title' || new RegExp('-' + ct + '$').test(product.handle || '')) { ct = ''; }
        restockTag.value = ('restock-' + (product.handle || 'guard') + (ct ? '-' + ct : ''))
          .replace(/[^a-z0-9-]+/g, '-');
      }
      if (notifyBody) {
        var tpl = notifyBody.getAttribute('data-notify-body') || '';
        if (tpl) notifyBody.textContent = tpl.replace(/\{guard\}/g, guardName());
      }
    }



    function swapMainImage(src) {
      if (!img || !src) return;
      img.style.opacity = '0';
      img.style.transform = 'scale(0.97)';
      setTimeout(function () {
        /* srcset wins over src, so it has to go before the swap can take */
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = src;
        img.style.opacity = '1';
        img.style.transform = 'scale(1)';
      }, 180);
    }

    function setActiveThumbBySrc(src) {
      if (!src) return;
      var base = src.split('?')[0].split('/').pop();
      thumbs.forEach(function (t) {
        t.classList.toggle('active', t.getAttribute('data-src').split('?')[0].split('/').pop() === base);
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        /* Picking a photo ends the clip — otherwise it keeps playing over the
           top of whatever the shopper just chose. */
        settleVideo();
        var src = t.getAttribute('data-src');
        swapMainImage(src);
        /* Re-pick the supporting tiles so the new hero isn't shown twice.
           Match by src afterwards rather than flagging the clicked element —
           a supporting tile may have just been repointed at a different photo. */
        updateSideShots(currentCase, src);
        setActiveThumbBySrc(src);
      });
    });

    /* ── Supporting tiles under the hero ──
       These sit in fixed cells, so hiding one on a case change would punch a
       hole in the grid. Instead they're repointed at photos of the selected
       case, which keeps the rule the shopper cares about: a PSA selection only
       ever shows PSA photos. If a case doesn't have two square shots to spare,
       the row is dropped and the gallery falls back to the hero alone. */
    var sideWrap = root.querySelector('.pp-side');
    var sideTiles = [].slice.call(root.querySelectorAll('.pp-side-shot'));
    var ppFrame = root.querySelector('.pp-frame');
    var sidePool = [];
    try { sidePool = JSON.parse(root.querySelector('[data-side-pool]').textContent); } catch (e) {}

    function fileOf(u) { return (u || '').split('?')[0].split('/').pop(); }

    function updateSideShots(caseLabel, heroSrc) {
      if (!sideWrap || !sideTiles.length) return;
      var hero = fileOf(heroSrc);
      var pick = sidePool.filter(function (s) {
        if (caseLabel && s.case && s.case !== caseLabel) return false;
        /* Never repeat whatever is currently filling the hero tile */
        return fileOf(s.full) !== hero;
      });
      var enough = pick.length >= sideTiles.length;
      sideWrap.hidden = !enough;
      if (ppFrame) ppFrame.classList.toggle('pp-frame--solo-hero', !enough);
      if (!enough) return;
      sideTiles.forEach(function (t, i) {
        var s = pick[i];
        t.setAttribute('data-src', s.full);
        t.setAttribute('data-case', s.case || '');
        t.classList.remove('active');
        var im = t.querySelector('img');
        if (im && fileOf(im.getAttribute('src')) !== fileOf(s.thumb)) {
          im.src = s.thumb;
          im.alt = s.alt || '';
        }
      });
    }

    /* Show only the selected case's photos (untagged photos always show).
       The supporting tiles are handled by updateSideShots above, which swaps
       their contents rather than hiding them. */
    function filterThumbs(caseLabel) {
      var visible = 0;
      thumbs.forEach(function (t) {
        if (t.classList.contains('pp-side-shot')) { t.style.display = ''; return; }
        var c = t.getAttribute('data-case');
        var show = !caseLabel || !c || c === caseLabel;
        t.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (visible === 0) {
        thumbs.forEach(function (t) { t.style.display = ''; });
      }
    }

    function variantForCase(caseLabel) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if ((v.option1 || '').toLowerCase().indexOf(caseLabel.toLowerCase()) !== -1) return v;
      }
      return product.variants[0];
    }

    function selectCase(btn, caseLabel) {
      toggle.querySelectorAll('button').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      currentCase = caseLabel;
      filterThumbs(caseLabel);
      selectedVariant = variantForCase(caseLabel);
      var heroNext = (selectedVariant.featured_image && selectedVariant.featured_image.src) || (img && img.src);
      updateSideShots(caseLabel, heroNext);
      if (priceEl) priceEl.textContent = formatMoney(selectedVariant.price);
      if (addBtn) {
        addBtn.disabled = !selectedVariant.available;
        addBtn.textContent = selectedVariant.available ? 'Add to cart' : 'Sold out';
      }
      if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
        swapMainImage(sizedImg(selectedVariant.featured_image.src, 1400));
        setActiveThumbBySrc(selectedVariant.featured_image.src);
      }
      updateNotify();
      playIntro();
    }

    if (toggle) {
      toggle.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () { selectCase(btn, btn.getAttribute('data-case')); });
        var v = variantForCase(btn.getAttribute('data-case'));
        if (v && !v.available) {
          btn.classList.add('soldout');
          btn.title = 'Sold out';
        }
      });
      var activeBtn = toggle.querySelector('button.active');
      if (activeBtn) {
        currentCase = activeBtn.getAttribute('data-case') || '';
        filterThumbs(currentCase);
      }
    }
    /* Liquid already renders the opening case's photos, so this is a no-op on
       first paint; it matters once a thumbnail or the toggle moves the hero. */
    updateSideShots(currentCase, img && img.getAttribute('src'));

    if (addBtn) {
      addBtn.disabled = !selectedVariant.available;
      addBtn.textContent = selectedVariant.available ? 'Add to cart' : 'Sold out';
      addBtn.addEventListener('click', function () {
        if (!selectedVariant.available) return;
        /* A second tap while the first is still adding is ignored — nothing
           on screen changed until the add came back, so it added two. The
           sticky bar's button clicks this one, so it is covered too. */
        if (addBtn.getAttribute('aria-busy') === 'true') return;
        addBtn.setAttribute('aria-busy', 'true');
        addBtn.textContent = 'Adding…';
        /* The phone's sticky bar stands in for this button once it has
           scrolled away, so it says "Adding…" too — tapped, it gave nothing
           back for about 2 seconds until the drawer opened. */
        var sticky = document.querySelector('[data-pp-sticky-btn]');
        var stickyText = sticky ? sticky.textContent : '';
        if (sticky) { sticky.setAttribute('aria-busy', 'true'); sticky.textContent = 'Adding…'; }
        function done() {
          addBtn.removeAttribute('aria-busy');
          addBtn.textContent = selectedVariant.available ? 'Add to cart' : 'Sold out';
          if (sticky) { sticky.removeAttribute('aria-busy'); sticky.textContent = stickyText; }
        }
        window.cgAddToCart({ id: selectedVariant.id, quantity: 1 }, String(product.title || '').replace(/ Slab Display Case/g, '')).then(done, done);
      });
    }

    updateNotify();

    /* A failed or successful post reloads the page, so reopen the form on the
       variant the shopper was actually looking at rather than the default. */
    if (notifyWrap && root.querySelector('.pp-notify-ok, .pp-notify-err')) {
      var soldBtn = toggle && toggle.querySelector('button.soldout');
      if (soldBtn) selectCase(soldBtn, soldBtn.getAttribute('data-case'));
    }

    /* Hold the intro until the panel is actually on screen — no point spending
       a shopper's data on a clip they scrolled straight past. */
    if (stageVideo) {
      var stage = root.querySelector('.pp-stage');
      if ('IntersectionObserver' in window && stage) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { io.disconnect(); playIntro(); }
          });
        }, { threshold: 0.35 });
        io.observe(stage);
      } else {
        playIntro();
      }
    }
  }

})();
